export default {
    // Common
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    remove: 'Remove',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    create: 'Create',
    back: 'Back',
    clear: 'Clear',
    optional: 'optional',
    close: 'Close',
    expand: 'Expand',
    collapse: 'Collapse',
    confirm: 'Confirm',
    decline: 'Decline',
    accept: 'Accept',
    loading: 'Loading…',
    noResults: 'No results found',
    noResultsHint: 'Try adjusting your filters or search terms',
    actions: 'Actions',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    yes: 'Yes',
    no: 'No',
    search: 'Search…',
    filter: 'Filter',
    all: 'All',
    total: 'Total',
    notes: 'Notes',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    price: 'Price',
    duration: 'Duration',
    category: 'Category',
    description: 'Description',
    dashboard: 'Dashboard',
    settings: 'Settings',
    profileLabel: 'Profile',
    logout: 'Log out',
    today: 'Today',
    tomorrow: 'Tomorrow',
    upcoming: 'Upcoming',
    past: 'Past',
    calMode: { day: 'Day', week: 'Week', month: 'Month' },
    language: 'Language',
    pagination: { page: 'Page', of: 'of', item: 'item', items: 'items', total: 'total' },
    trialBanner: {
        daysLeft: 'Free trial — {{days}} days left',
        endsToday: 'Free trial ends today',
        endsOn: 'ends {{date}}',
        upgrade: 'Upgrade to keep your shop running',
    },
    // Shown to a shop's staff once its trial or plan has ended (PlanEnded.tsx)
    planEnded: {
        titleTrial: "Your free trial has ended",
        titlePlan: "Your GetFade plan has ended",
        titleSuspended: "This shop has been paused",
        dataSafe: "Your appointments, clients and barbers are all kept. Nothing has been deleted.",
        off: "The dashboard, the iPhone app and your online booking page are switched off for now.",
        renew: "To keep using GetFade it's €10 a month. Email us and we'll switch your shop back on.",
        renewSuspended: "Email us and we'll help you get your shop back.",
        emailCta: "Email us to continue",
        emailSubject: "Continue GetFade: {{shop}}",
        askOwner: "Ask your shop owner to renew the plan to get back in.",
        signOut: "Sign out",
        endedOn: "Ended {{date}}",
    },


    // Legal pages (Privacy / Terms / Security)
    legal: {
        updated: 'Last updated',
        rights: 'All rights reserved.',
        contact: {
            title: 'Contact us',
            body: 'Questions about this policy? Reach out at getfade.io@gmail.com and we will get back to you within a few business days.',
        },
        privacy: {
            title: "Privacy Policy",
            updated: "2 November 2026",
            intro: "This policy explains how GetFade — the website getfade.io and the GetFade apps for iPhone, iPad and Android — handles personal data. GetFade is run by Ramadan Durguti, an individual based in Kosovo (“we”, “us”). You can reach us at getfade.io@gmail.com.",
            sections: [
                { title: "Who is responsible", body: "We are responsible for the data of shop owners and staff who use GetFade. For the data of a shop’s customers (bookings, names, contact details), the barbershop is responsible and we process it on the shop’s behalf, only to run the service for them. Customers with questions about their booking data can contact the shop or us." },
                { title: "Information we collect", body: "Account data: name, email address, password (stored hashed), account identifier, language and an optional profile photo. Shop data: shop name, address, logo, opening hours, services, prices and team members. Booking data entered by shops or their customers: customer names, phone numbers, email addresses, appointment times, services and notes. Photos and videos you choose to add. Technical data: IP address, browser and device type, sign-in sessions, security logs and cookies. Push-notification tokens, if you allow notifications in a GetFade app." },
                { title: "Sign in with Apple and Google", body: "If you use Sign in with Apple, we receive your name, your email address (which may be an Apple private-relay address) and an Apple account identifier. If you use Continue with Google, on the website or in the apps, we receive your name, your email address and a Google account identifier. We use these only to create your account and sign you in." },
                { title: "App permissions", body: "The GetFade apps ask for camera access only when you choose to take a photo or scan a QR code, and for microphone access only when you choose to record a video. Photo-library access is used only to save images and files you export, such as QR codes. The name, email address, phone number, photos and videos, other content you add and account identifier handled in the apps are used only to make the apps work. We do not track you." },
                { title: "How we use it and why", body: "To provide the service you signed up for: online booking, calendars, client records, reports, booking confirmations and reminders by email, and booking alerts in the app and as push notifications (performance of a contract). To keep GetFade secure and prevent abuse, for example bot protection on public booking forms (legitimate interest). To meet legal obligations. Optional cookies are used only with consent. We do not sell personal data and do not use it for advertising or cross-app tracking." },
                { title: "Service providers", body: "We share data only with providers that help us run GetFade, under data-protection terms: our cloud hosting provider (servers and database); Resend (sending emails); Cloudflare Turnstile (bot protection on public booking forms); Apple (optional Sign in with Apple in the apps); Google (optional Continue with Google on the website and in the apps, and web fonts); Apple Push Notification service and Google Firebase Cloud Messaging (delivering push notifications to the iPhone and Android apps). We may also disclose data where the law requires it." },
                { title: "International transfers", body: "Some of these providers process data outside Kosovo and the EU, for example in the United States. Where that happens we rely on the provider’s legal safeguards, such as the EU Standard Contractual Clauses or an adequacy decision." },
                { title: "How long we keep data", body: "Account and shop data are kept while the account is active. When you delete your account in Settings → Security it is removed straight away; when the last administrator of a shop deletes their account, the shop and its booking data are deleted too, along with the staff accounts that only exist for that shop. Copies in backups are overwritten within 30 days. Security logs and sessions are kept only as long as needed to protect the service. Push tokens are removed when you sign out of the app or uninstall it." },
                { title: "Your rights", body: "You can access, correct, export or delete your personal data, object to processing based on legitimate interest, and withdraw consent at any time. Most of this you can do yourself in your account settings; otherwise email getfade.io@gmail.com and we will answer within 30 days. You also have the right to complain to the Information and Privacy Agency of Kosovo (AIP) or to the data-protection authority in your country." },
                { title: "Children", body: "GetFade is not directed at children. Shop accounts are for people aged 18 or over. Customers under 16 should book with the help of a parent or guardian." },
                { title: "Security", body: "Data is encrypted in transit, sensitive fields are encrypted at rest, and access is restricted. See our Security page for details." },
                { title: "Cookies", body: "We use essential cookies to keep you signed in and remember your preferences. Optional cookies are only set after you agree in the cookie banner. Details are in our Cookie Policy." },
                { title: "Changes to this policy", body: "We will update this policy when GetFade changes. If a change is significant, we will tell you by email or in the app before it takes effect." },
            ],
        },
        support: {
            title: "GetFade Support",
            updated: "2 November 2026",
            intro: "Need help with your account, appointments, or shop settings? Email <mail>getfade.io@gmail.com</mail>. Include your shop name and a description of the issue. Never send your password.",
            signInTitle: "Signing in on iPhone and iPad",
            signInBody: "The iPhone and iPad app supports email and password, Sign in with Apple and Continue with Google. Forgot your password, or want to add one to an account you created with Apple or Google? Choose <forgot>Forgot password</forgot> and use the same email address.",
            deleteTitle: "Account deletion",
            deleteBody: "Open Settings, then Security, then Delete account. If your account has a password, enter it first. We then email you a 6-digit code; enter it to finish. Accounts without a password (created with Apple or Google) only need the code. Your account is removed straight away. When the last administrator of a shop deletes their account, the shop and its booking data are deleted too, along with the staff accounts that only exist for that shop. This cannot be undone.",
            privacyTitle: "Privacy",
            privacyBody: "Read our <privacy>Privacy Policy</privacy> and <terms>Terms of Service</terms>.",
        },
        terms: {
            title: "Terms of Service",
            updated: "October 2026",
            intro: "These terms apply to your use of GetFade — the website getfade.io and the GetFade apps — provided by Ramadan Durguti, an individual based in Kosovo (“we”, “us”). By creating an account or using GetFade you agree to them. Contact: getfade.io@gmail.com.",
            sections: [
                { title: "Your account", body: "You must be at least 18 years old to create a shop account. Keep your login details safe; you are responsible for activity under your account and for the team members you invite." },
                { title: "Using the service", body: "Use GetFade to run your barbershop and manage its bookings and customers. Do not use it for anything unlawful, to send spam, or to interfere with the service or other users." },
                { title: "Free trial and price", body: "New shops get a 3-month free trial with all features and no payment card required. After the trial GetFade costs €10 per month per shop. We will contact you before the trial ends to arrange payment directly with us; there are no purchases inside the apps. If you do not continue, we may pause your shop until a plan is active. Prices are in euros; any applicable taxes will be shown on your invoice." },
                { title: "Cancellation", body: "You can stop your plan at any time; it ends at the end of the month already paid, and no partial refunds are given except where the law requires. If you use GetFade as a consumer rather than a business, you keep any rights mandatory consumer law gives you." },
                { title: "Your data and your customers’ data", body: "You own the business, customer and booking data you put into GetFade. You are responsible for having a lawful basis to share your customers’ data with us. We process it only on your behalf and as described in our Privacy Policy." },
                { title: "Availability", body: "We work to keep GetFade available around the clock, but we cannot guarantee uninterrupted service. We announce planned maintenance where possible." },
                { title: "Ending your account", body: "You can delete your account at any time in Settings → Security. If you are the last administrator of a shop, deleting your account also deletes the shop and its data. We may suspend or close accounts that break these terms, with notice where reasonable." },
                { title: "Liability", body: "GetFade is provided “as is”. To the extent the law allows, we are not liable for indirect or consequential losses, and our total liability is limited to the fees you paid us in the 12 months before the claim. Nothing in these terms limits liability that cannot be limited by law." },
                { title: "Governing law", body: "These terms are governed by the laws of the Republic of Kosovo, and disputes go to the competent courts of Kosovo. If you are a consumer, you also keep the protection of the mandatory laws of the country where you live." },
                { title: "Changes", body: "We may update these terms as GetFade evolves. We will announce material changes by email or in the app at least 14 days before they take effect." },
            ],
        },
        security: {
            title: 'Security',
            updated: 'April 2026',
            intro: 'We take the protection of your shop’s data seriously. Here’s how GetFade keeps customer information and bookings safe.',
            sections: [
                { title: 'Encryption', body: 'All traffic between your devices and GetFade is encrypted in transit using TLS 1.2+. Sensitive data at rest is encrypted with AES-256.' },
                { title: 'Infrastructure', body: 'GetFade runs on managed cloud hosting with encrypted connections to the database. Access to production systems is restricted to the operators who need it.' },
                { title: 'Access control', body: 'Only the team members you invite can access your shop data. Internal access by GetFade staff is strictly limited, logged, and used only for support or operational needs.' },
                { title: 'Data protection', body: 'Sensitive fields — customer phone numbers and notes, and authentication secrets — are encrypted at rest in the database, not just in transit. GetFade does not process card payments and never handles card numbers.' },
                { title: 'Authentication', body: 'Passwords are hashed with industry-standard algorithms. Two-factor authentication is available and recommended for all shop owners.' },
                { title: 'Responsible disclosure', body: 'Found a vulnerability? Please email getfade.io@gmail.com. We welcome good-faith reports and will respond quickly.' },
            ],
        },
    },

    // Days of week
    days: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
    },

    // Days of week (short, for calendar headers)
    daysShort: {
        monday: 'Mo',
        tuesday: 'Tu',
        wednesday: 'We',
        thursday: 'Th',
        friday: 'Fr',
        saturday: 'Sa',
        sunday: 'Su',
    },

    // Days of week (lowercase for "returns to" context)
    daysAccusative: {
        monday: 'monday',
        tuesday: 'tuesday',
        wednesday: 'wednesday',
        thursday: 'thursday',
        friday: 'friday',
        saturday: 'saturday',
        sunday: 'sunday',
    },

    // Months
    months: {
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December',
    },

    // Time Off
    timeoff: {
        title: 'Time Off',
        deleteTitle: 'Delete Time Off',
        manage: 'Manage absences and time off',
        add: 'Add Time Off',
        noTimeOff: 'No time off scheduled.',
        upcomingActive: 'Upcoming & Active',
        from: 'From',
        to: 'To',
        reason: 'Reason (optional)',
        reasonPlaceholder: 'e.g. Vacation, sick leave…',
    },

    // Nav
    nav: {
        dashboard: 'Dashboard',
        appointments: 'Appointments',
        customers: 'Clients',
        barbers: 'Barbers',
        services: 'Services',
        haircuts: 'Haircuts',
        products: 'Products',
        reports: 'Reports',
        ads: 'Marketplace',
        waitlist: 'Waitlist',
        auditLogs: 'Audit Logs',
        workspace: 'Workspace',
        account: 'Account',
        myProfile: 'My Profile',
        signOut: 'Sign Out',
        settings: 'Settings',
        more: 'More',
        bookingLink: 'Booking Page',
        copyBookingLink: 'Copy booking link',
        groupMain: 'Overview',
        groupManage: 'Manage',
        groupInsights: 'Insights',
        groupSettings: 'Settings',
        dashboardDesc: 'Stats, revenue & upcoming',
        appointmentsDesc: 'All bookings & walk-ins',
        history: 'History',
        historyDesc: 'Past & completed appointments',
        customersDesc: 'Your client list & profiles',
        barbersDesc: 'Team members & schedules',
        timeoffDesc: 'Manage time off requests',
        servicesDesc: 'Haircuts, trims & more',
        haircutsDesc: 'Customize haircut styles',
        productsDesc: 'Retail & inventory',
        reportsDesc: 'Revenue & analytics',
        settingsDesc: 'Shop info & preferences',
        myProfileDesc: 'Edit your account info',
        signOutDesc: 'End your session',
        signOutConfirm: 'Are you sure you want to sign out?',
    },

    // Dashboard
    dash: {
        todayAppointments: "Today's Appointments",
        totalCustomers: 'Total Clients',
        activeBarbers: 'Active Barbers',
        activeServices: 'Active Services',
        revenueToday: "Today's Revenue",
        pendingConfirmation: 'Pending Confirmation',
        completionRate: 'Completion rate',
        todayThroughput: "Today's appointments",
        bookingsByHour: 'Bookings by hour — revenue on completed',
        bookings: 'Bookings',
        revenue: 'Revenue',
        upcomingAppointments: 'Upcoming Appointments',
        recentActivity: 'Recent Activity',
        noUpcoming: 'No upcoming appointments.',
        noRecent: 'No recent appointments.',
        lowStock: 'Low Stock Alert',
        viewProducts: 'View Products',
        dismiss: 'Dismiss',
        monthlyGoals: 'Monthly Goals',
        setGoals: 'Set Goals',
        editGoals: 'Edit',
        noGoals: 'No goals set for this month.',
        setGoalsLink: 'Set goals',
        revenueGoal: 'Revenue',
        bookingsGoal: 'Bookings',
        bookingsTrend: 'Bookings Trend',
        last14: 'Last 14 days',
        shopView: 'Shop',
        mySchedule: 'My Schedule',
        todaySchedule: "Today's Schedule",
        topBarber: 'Top Barber This Week',
        topService: 'Most Booked Service',
        repeatCustomers: 'Repeat Clients',
        noShowRate: 'No-Show Rate',
        barberPerf: 'Barber Performance',
        thisMonth: 'This month',
        upcoming: 'Upcoming',
        nextScheduled: 'Next scheduled appointments',
        viewAll: 'View all',
        noToday: 'No appointments today',
        noBookingsToday: 'No bookings today',
        chartHint: 'The chart lights up once appointments come in',
        noTodayHint: 'Appointments show up here the moment they are booked.',
        noMatches: 'No matches for your filters',
        clearOrPress: 'Clear the search or switch pills. Press',
        toCreateOne: 'to create one.',
        gettingStarted: 'Getting started',
        newAppointment: 'New appointment',
        noShowAbove: 'Above healthy range',
        noShowWithin: 'Within healthy range',
        noUpcomingFull: 'No upcoming appointments',
        completed: 'completed',
        noShow: 'no-show',
        noShows: 'no-shows',
        vsLastMonth: 'vs last month',
        thisWeek: 'this week',
        setMonthlyGoals: 'Set Monthly Goals',
        revenueTarget: 'Revenue Target ($)',
        bookingsTarget: 'Bookings Target',
        saveGoals: 'Save Goals',
        lowStockAlert: 'Low stock alert',
        appointmentSingular: 'appointment',
        appointments: 'appointment',
        appointmentsPlural: 'appointments',
        walkin: 'Walk-in',
        customize: 'Dashboard Customization',
        kpiCards: "KPI Cards (Today's Stats)",
        weeklyInsights: 'Weekly Insights',
        todaysSchedule: "Today's Schedule",
        upcomingAppointmentsList: 'Upcoming Appointments',
        goodDay: 'Good day',
        live: 'Live',
        unassigned: 'Unassigned',
        allClear: 'All clear',
        filter: 'Filter…',
        group: 'Group',
        groupBy: 'Group by',
        regulars: 'Regulars',
        returningCustomers: 'Returning customers',
        allAppointments: 'All',
        pendingAppointments: 'Pending',
        activeAppointments: 'Active',
        completedAppointments: 'Completed',
        confirmCount: 'Confirm {{count}}',
        firstAt: 'First at {{time}}',
        noBookingsYet: 'No bookings yet',
        completedCount: 'completed',
        bookingsCount: 'bookings',
    },
    common: {
        needsAction: 'Needs action',
    },
    appointmentStatus: {
        pending: 'Pending',
        confirmed: 'Confirmed',
        inProgress: 'In progress',
        completed: 'Completed',
        cancelled: 'Cancelled',
        noShow: 'No-show',
        noShowThisWeek: 'no-show this week',
        today: 'Today',
    },

    // Appointments
    appt: {
        title: 'Appointments',
        history: 'History',
        new: 'New Appointment',
        newDesc: 'Fill in the details to create a new appointment.',
        create: 'Create Appointment',
        edit: 'Edit Appointment',
        barber: 'Barber',
        customer: 'Client',
        service: 'Service',
        startsAt: 'Start Time',
        endsAt: 'End Time',
        status: 'Status',
        price: 'Price',
        notes: 'Notes',
        time: 'Time',
        summary: 'Summary',
        stillNeed: 'Still need',
        stepsDone: 'complete',
        dateFilter: 'Date Range',
        pending: 'Pending',
        confirmed: 'Confirmed',
        inProgress: 'In Progress',
        completed: 'Completed',
        cancelled: 'Cancelled',
        noShow: 'No Show',
        show: 'Show',
        hide: 'Hide',
        cancelledBy: 'Cancelled by',
        cancelledBy_customer: 'Cancelled by customer',
        cancelledBy_staff: 'Cancelled by shop',
        openFull: 'Open full details',
        bookingSource: 'Booking Source',
        noAppointments: 'No appointments found.',
        noAppointmentsHint: 'These are the only available slots — all other times are already booked.',
        cancelAppt: 'Cancel Appointment',
        markComplete: 'Mark Complete',
        markNoShow: 'Mark No-Show',
        selectBarberAndServiceFirst: 'Select a barber and service first to see available times.',
        selectServiceFirst: 'Pick a service to see barbers availability.',
        checkingAvailability: 'Checking availability…',
        availableTimes: 'Available Times',
        slotsAvailable: 'open',
        noSlotsOnDate: 'No available slots on this day — barber is off or fully booked.',
        tryDifferentDate: 'Try a different date.',
        tryDifferentDateOrBarber: 'Try a different date or barber.',
        doesntWorkThisDay: "doesn't work on this day.",
        nextWorkingDay: 'Next working day',
        clearDates: 'Clear dates',
        allCaughtUp: 'All caught up!',
        closing: 'Closing…',
        bookingDetails: 'Booking Details',
        bookingDetailsDesc: 'Fill in the information below to schedule a new session.',
        editDesc: 'Update the information below to modify this session.',
        assignedBarber: 'Assigned Barber',
        customerName: 'Client Name',
        searchCustomer: 'Search or type client name...',
        autoFilledHint: 'Barber & service auto-filled from last visit. You can change them.',
        hidePast: 'Hide past appointments',
        showPast: 'Show past appointments',
        phoneNumber: 'Phone Number',
        serviceType: 'Service Type',
        dateTime: 'Date & Time',
        internalNotes: 'Internal Notes',
        notesPlaceholder: 'Allergies, preferences, etc...',
        estimatedPrice: 'Estimated Price:',
        repeat: 'Repeat',
        doesNotRepeat: 'Does not repeat',
        weekly: 'Weekly',
        biweekly: 'Every 2 weeks',
        monthly: 'Monthly',
        bookAppointment: 'Book Appointment',
        updateAppointment: 'Update Appointment',
        tip: 'Tip ($)',
        recurringAppt: 'This is a recurring appointment',
        thisOnly: 'This appointment only',
        thisFuture: 'This and all future',
        selectBarber: 'Select barber',
        selectService: 'Select service',
        selectDate: 'Select date',
        selectTime: 'Select time',
        selectServices: 'Select services',
        barberFreeToday: 'is free today',
        barberNotAvailableToday: 'is not available today',
        review: 'Review',
        customerInfo: 'Client Information',
        pendingDesc: 'Waiting for confirmation',
        clickToCreate: 'Click to create appointment',
        can: 'Can',
        starts: 'Starts',
        ends: 'Ends',
        apptStatus: 'Appointment Status',
        deleteAppt: 'Delete Appointment',
        deleteConfirm: 'Are you sure you want to delete this appointment? This cannot be undone.',
        deleteThisOnly: 'Delete this appointment only',
        deleteThisFuture: 'Delete this and all future',
        myAppointments: 'My Appointments',
        allAppointments: 'All Appointments',
        mine: 'Mine',
        exportCsv: 'Export CSV',
        view: 'View',
        walkIn: 'Walk-in',
        staff: 'Staff',
        newPendingBooking: 'New booking request',
        riskHigh: 'High risk',
        riskMedium: 'Suspicious',
        riskFlag_no_phone: 'No phone number provided',
        riskFlag_new_customer: 'First-time client',
        riskFlag_has_no_show: 'Has missed appointments before',
        riskFlag_frequent_no_show: 'Frequently misses appointments',
        riskFlag_restricted_trust: 'Restricted account',
        riskFlag_high_ip_activity: 'Multiple bookings from same device',
        riskFlag_frequent_canceller: 'Frequently cancels bookings',
        riskFlag_recent_cancel: 'Recently cancelled a booking',
        notFound: 'Appointment Not Found',
        notFoundTitle: 'Appointment Not Found',
        notFoundDesc: 'This appointment may have been deleted or is no longer available. Please check the appointment list for current bookings.',
        backToList: 'Back to Appointments',
        deletedBanner: 'This appointment has been deleted and is shown in read-only mode.',
    },

    // Services
    svc: {
        title: 'Services',
        new: 'New Service',
        create: 'Create Service',
        edit: 'Edit Service',
        serviceName: 'Service Name',
        durationMin: 'Duration (Minutes)',
        priceDollar: 'Price (€)',
        colorLabel: 'Color Label',
        activeStatus: 'Active Status',
        activeDesc: 'Service will be visible for booking immediately.',
        activeEditDesc: 'Allow clients to see and book this service.',
        serviceDesc: 'Service Description',
        newDesc: 'Define a new offering for your shop, including duration and pricing.',
        editDesc: 'Update the details and pricing for this service offering.',
        noServices: 'No services yet.',
        created: 'Service created.',
        updated: 'Service updated.',
        deleted: 'Service deleted.',
        updateService: 'Update Service',
        uncategorized: 'Uncategorized',
        clearColor: 'Clear',
        descPlaceholder: 'Provide details about what this service entails…',
        deleteConfirm: 'Are you sure you want to delete this service? This action cannot be undone.',
        serviceNamePlaceholder: 'e.g. Classic Haircut',
        categoryPlaceholder: 'e.g. Haircuts',
    },

    // Haircuts
    hair: {
        title: 'Haircuts',
        new: 'New Haircut',
        create: 'Create Haircut',
        edit: 'Edit Haircut',
        editDesc: 'Update haircut details',
        createNew: 'Create New Haircut',
        addCustom: 'Add a custom haircut style for your shop',
        image: 'Image',
        uploadImage: 'Upload image',
        imagePlaceholder: 'PNG, JPG up to 5MB',
        name: 'Name',
        namePlaceholder: 'e.g., Classic Fade',
        description: 'Short Description',
        descPlaceholder: 'e.g., Timeless and clean',
        detailedDesc: 'Detailed Description',
        detailedDescPlaceholder: 'Full description for AI image generation (optional)',
        active: 'Active',
        activeDesc: 'Show this haircut to clients',
        createBtn: 'Create Haircut',
        updateBtn: 'Update Haircut',
        creating: 'Creating...',
        noHaircuts: 'No haircuts yet.',
        deleteConfirm: 'Are you sure you want to delete this haircut?',
        deleted: 'Haircut deleted.',
        created: 'Haircut created.',
        updated: 'Haircut updated.',
    },

    // Barbers
    barber: {
        title: 'Barbers',
        new: 'New Barber',
        create: 'Create Barber',
        edit: 'Edit Barber',
        info: 'Information',
        specialty: 'Specialty',
        rating: 'Rating',
        totalReviews: 'Total Reviews',
        noBarbers: 'No barbers yet.',
        schedule: 'Schedule',
        workingHours: 'Working Hours',
        weeklyWorkingHours: 'Weekly Working Hours',
        scheduleDescription: 'Toggle days on/off and set start & end times. Appointments can only be booked during active hours.',
        dayOff: 'Day off',
        to: 'to',
        applyToWeekdays: 'Apply to Mon–Fri',
        saveSchedule: 'Save Schedule',
        maxClosingHour: 'Maximum Closing Hour',
        maxClosingHourDesc: 'Set the latest time barbers can end their day. This limits available closing times in scheduling.',
        googleCalendar: 'Google Calendar',
        googleCalendarDesc: "Sync appointments to this barber's Google Calendar.",
        connected: 'Connected',
        notConnected: 'Not Connected',
        connect: 'Connect',
        disconnect: 'Disconnect',
        fullName: 'Full Name',
        emailAddress: 'Email Address',
        initialPassword: 'Initial Password',
        specialtyExpertise: 'Specialty / Expertise',
        calendarColor: 'Calendar Color',
        color: 'Color',
        professionalBio: 'Professional Bio',
        bio: 'Bio',
        bioPlaceholder: 'Write a short bio...',
        activeSchedule: 'Active Schedule',
        activeScheduleDesc: 'Toggle whether this barber is available for booking.',
        createDescription: 'Add a new barber to your team.',
        newDesc: 'Create a new professional profile and login credentials for a barber.',
        editDesc: 'Modify barber profile details, contact information, and status.',
        updateBarber: 'Update Barber',
        you: 'You',
        generalist: 'Generalist',
        offToday: 'Off Today',
        returnsTo: 'Returns',
        markAvailable: 'Mark available today',
        markUnavailable: 'Mark unavailable today',
        deleteConfirm: 'Are you sure you want to remove this barber? This will affect their availability and future schedule.',
        namePlaceholder: 'e.g. Marcus Wright',
        emailPlaceholder: 'barber@example.com',
        passwordPlaceholder: '••••••••',
        specialtyPlaceholder: 'e.g. Beard Sculpting',
    },

    // Clients
    cust: {
        title: 'Clients',
        new: 'New Client',
        create: 'Create Client',
        edit: 'Edit Client',
        addCustomer: 'Add Client',
        editCustomer: 'Edit Client',
        deleteCustomer: 'Delete Client',
        deleteConfirm: 'Are you sure? This will soft-delete the client.',
        name: 'Name',
        phone: 'Phone',
        email: 'Email',
        address: 'Address',
        notes: 'Notes',
        visits: 'Visits',
        noShows: 'No-shows',
        cancellations: 'Cancellations',
        byStaff: 'by staff',
        byCustomer: 'by client',
        loyalty: 'Loyalty',
        trust: 'Trust',
        loyaltyPoints: 'Loyalty Points',
        lastVisit: 'Last Visit',
        favoriteBarber: 'Fav. Barber',
        noCustomers: 'No clients yet.',
        noCustomersDesc: 'Clients are added automatically when they book, or you can add them manually.',
        noCustomersYet: 'No customers yet',
        trustOk: 'Trusted',
        trustRestricted: 'Restricted',
        trustBlocked: 'Blocked',
        searchPlaceholder: 'Search...',
        namePlaceholder: 'e.g. John Doe',
        phonePlaceholder: '+1 555 000 0000',
        noResults: 'No clients found.',
        addNew: 'Add new client',
        quickCode: 'Code',
        hasNoShows: 'Has no-shows',
        noNoShows: 'No no-shows',
        clearFilters: 'Clear filters',
        sortBy: 'Sort by',
        sortByVisits: 'Sort by visits',
        mostVisits: 'Most visits',
        leastVisits: 'Least visits',
        mostNoShows: 'Most no-shows',
        leastNoShows: 'Least no-shows',
        defaultSort: 'Default',
        resetPassword: 'Reset password',
        resetPasswordTitle: 'Reset password',
        resetPasswordDesc: 'Set a new password for {{name}}. Make sure to share it securely.',
        newPassword: 'New password',
        confirmPassword: 'Confirm password',
        savePassword: 'Save password',
    },

    // Products
    prod: {
        title: 'Products',
        new: 'New Product',
        create: 'Create Product',
        edit: 'Edit Product',
        stock: 'Stock',
        lowStock: 'Low Stock',
        noProducts: 'No products yet.',
        stockQty: 'Stock Quantity',
        lowStockThreshold: 'Low Stock Threshold',
        lowStockAlert: 'Low Stock Alert',
        lowStockHint: 'Show warning badge when stock falls to or below this number.',
        productName: 'Product Name',
        activeStatus: 'Active Status',
        activeDesc: 'Product will be available to add to appointments.',
        newDesc: 'Add a retail product to your inventory for sale at appointments.',
        editDesc: 'Update the details and stock levels for this product.',
        updateProduct: 'Update Product',
        uncategorized: 'Uncategorized',
        priceDollar: 'Price (€)',
        stockQuantity: 'Stock Quantity',
        deleteConfirm: 'Are you sure you want to delete this product? This action cannot be undone.',
        namePlaceholder: 'e.g. Pomade',
        categoryPlaceholder: 'e.g. Hair Care',
        image: 'Product Image',
        imageDesc: 'JPG, PNG or WebP, max 2MB.',
        imageInvalidType: 'Only JPG, PNG, or WebP images are allowed.',
        imageTooLarge: 'Image is {{size}} MB. Maximum size is 2 MB.',
        uploadImage: 'Upload Image',
        changeImage: 'Change Image',
        sku: 'SKU',
        skuPlaceholder: 'e.g. POM-001',
        skuHint: 'Unique product identifier or barcode.',
        costPrice: 'Cost Price',
        costPriceHint: 'What you pay your supplier (used for margin reporting).',
        margin: 'Margin',
        description: 'Description',
        descriptionPlaceholder: 'Optional notes shown on the product detail page.',
        category: 'Category',
        categoryNone: 'No category',
        addCategory: 'Add new category',
        manageCategories: 'Manage Categories',
        history: 'Stock History',
        historyEmpty: 'No stock movements yet.',
        movement: {
            sale: 'Sale',
            refund: 'Refund',
            adjustment: 'Adjustment',
            restock: 'Restock',
            initial: 'Initial Stock',
        },
    },

    // Profile
    profile: {
        title: 'Account Settings',
        general: 'General',
        security: 'Security',
        sessions: 'Sessions',
        dangerZone: 'Danger Zone',
        bookingLink: 'Your Booking Link',
        bookingLinkDesc: 'Share this link so clients can book online',
        copy: 'Copy',
        copied: 'Copied!',
        deleteAccount: 'Delete Account',
        profileInfo: 'Profile Information',
        profileInfoDesc: 'Update your account name and email address.',
        changePhoto: 'Change Photo',
        removePhoto: 'Remove Photo',
        saveChanges: 'Save Changes',
        saved: 'Saved.',
        emailUnverified: 'Your email is unverified.',
        resendEmail: 'Resend verification email.',
        verificationSent: 'A new verification link has been sent.',
    },

    // Booking (public)
    booking: {
        title: 'Book',
        languagePreference: 'Language',
        resendingCode: 'Resending…',
        confirmation: {
            title: 'Booking confirmed',
        },
        nav: {
            book: 'Book',
            appointments: 'My Appointments',
            profile: 'Profile',
        },
        chooseBarber: 'Choose a Barber',
        chooseServices: 'Choose Services',
        noServices: 'No Services Available',
        noServicesDesc: "The shop hasn't added any services yet.",
        pickDateTime: 'Pick a Date & Time',
        yourDetails: 'Your Details',
        errorNameRequired: 'Please enter your full name.',
        errorPhoneRequired: 'Please enter your phone number.',
        bookingSummary: 'Booking Summary',
        yourName: 'Your full name',
        yourPhone: 'Phone number',
        specialRequests: 'Any special requests?',
        confirmBooking: 'Confirm Booking',
        privacyNotice: 'Your details go to {{shop}} to manage your appointment, and are stored securely by GetFade. <privacy>Privacy Policy</privacy>',
        booking: 'Booking…',
        namePlaceholder: 'Your full name',
        phonePlaceholder: '+1 (555) 000-0000',
        emailPlaceholder: 'your@email.com',
        barber: 'Barber',
        date: 'Date',
        time: 'Time',
        loadingSlots: 'Loading available slots…',
        noSlots: 'No available slots on this day. Try a different date.',
        barberNotWorking: 'This barber doesn\'t work on this day. Please choose a different date.',
        barberOnTimeOff: 'This barber is on time off on this day. Please choose a different date.',
        loadingAvailability: 'Loading availability…',
        noSlotsBadge: 'No slots',
        continue: 'Continue',
        anyBarber: 'Any Available Barber',
        anyBarberDesc: 'First available slot among all barbers',
        anyBarberFastest: 'Fastest',
        anyBarberAutoAssign: 'The best available barber will be auto-assigned when you pick a time.',
        morning: 'Morning',
        afternoon: 'Afternoon',
        evening: 'Evening',
        services: 'Services',
        service: 'Service',
        min: 'min',
        totalPrice: 'Total price',
        with: 'with',
        tryingStyle: 'Trying this style',
        bookYourVisit: 'Book your visit.',
        heroSubtitle: 'Choose what you need, who you trust, and when. It only takes a minute.',
        selectedCount: 'selected',
        duration: 'Duration',
        step: {
            barber: 'Barber',
            service: 'Service',
            dateTime: 'Date & Time',
            info: 'Your Info',
        },
        // Confirmation
        confirmed: 'Booking Confirmed!',
        confirmedDesc: "You're all set. We look forward to seeing you.",
        pending: 'Appointment Received',
        pendingDesc: 'Your appointment is pending confirmation. We will contact you shortly.',
        appointmentDetails: 'Appointment Details',
        cancelWindow: 'Need to cancel? You have',
        graceWindow: 'Changed your mind? You can cancel within',
        cancelAppt: 'Cancel Appointment',
        cancelledTitle: 'Appointment Cancelled',
        cancelledDesc: 'Your appointment has been cancelled. We hope to see you another time.',
        unavailableTitle: "{{shop}} isn't taking online bookings right now",
        unavailableDesc: "Please contact the shop directly to book.",
        yourBookings: "Your bookings",
        viewOrCancel: "View or cancel",
        bookAnother: 'Book Another Appointment',
        shopPhone: "Shop's Phone",
        getDirections: 'Get directions',
        windowExpired: 'The cancellation window has expired.',
        viewMyAppts: 'View My Appointments',
        errorInvalidPhone: 'Please enter a valid phone number (7-15 digits or +1-15 digits)',
        checkStatus: 'Check Booking Status',
        statusTitle: 'Booking Status',
        statusPending: 'Waiting for Confirmation',
        statusPendingDesc: 'The shop will confirm your appointment shortly.',
        statusBadgePending: 'Pending',
        pendingHint: 'Come back in a few minutes to check if your appointment is approved. The status will update automatically.',
        bookAgain: 'Book again',
        products: 'Products',
        noProductsYet: 'No products yet.',
        outOfStock: 'Out of stock',
        addToCalendar: 'Add to Calendar',
        directions: 'Directions',
        callShop: 'Call',
        cancelAppointment: 'Cancel appointment',
        cancelConfirmTitle: 'Cancel appointment?',
        cancelConfirm: 'Are you sure you want to cancel this appointment? This action cannot be undone.',
        cancelKeep: 'Keep appointment',
        confirmCancel: 'Cancel appointment',
        cancelling: 'Cancelling…',
        appointmentCancelled: 'Appointment cancelled successfully',
        appointmentCancelFailed: 'Failed to cancel appointment',
        myProfile: 'My profile',
        profileTitle: 'My profile',
        profileInfo: 'My details',
        profileInfoDesc: 'Update your name, email and address.',
        fullName: 'Full name',
        emailLabel: 'Email',
        phoneLabel: 'Phone',
        phoneLocked: 'Phone cannot be changed',
        addressLabel: 'Address',
        save: 'Save',
        saved: 'Changes saved.',
        passwordSection: 'Password',
        passwordSectionDesc: 'Keep your account secure with a strong password.',
        deleteAccount: 'Delete my account',
        deleteAccountDesc: 'Removes your name, contact details and login for {{shop}} and cancels your upcoming bookings. Past visits stay in the shop’s records without your details.',
        deleteAccountConfirm: 'This cannot be undone.',
        deleteAccountButton: 'Delete account',
        deleteAccountButtonConfirm: 'Yes, delete my account',
        deleteAccountSendCode: 'Email me a code',
        deleteAccountCodeSent: 'We sent a 6-digit code to {{email}}. Enter it to delete your account.',
        deleteAccountCodeLabel: 'Code from the email',
        deleteAccountResend: 'Send a new code',
        accountDeleted: 'Your account has been deleted.',
        languageTitle: 'Preferred language',
        languageDesc: "We'll show this shop in your chosen language. Overrides the shop default.",
        languageNotSet: 'Not set - using shop default',
        languageActive: 'Active',
        changePassword: 'Change password',
        setPassword: 'Set password',
        currentPassword: 'Current password',
        newPassword: 'New password',
        confirmPassword: 'Confirm password',
        passwordUpdated: 'Password updated.',
        uploadPhoto: 'Upload photo',
        changePhoto: 'Change photo',
        stillNeed: 'Still need:',
        statusConfirmed: 'Your Appointment is Confirmed!',
        statusConfirmedDesc: 'Your appointment is confirmed. We look forward to seeing you.',
        statusBadgeConfirmed: 'Confirmed',
        statusInProgress: 'Your Appointment is In Progress',
        statusInProgressDesc: 'Your appointment is currently being served.',
        statusBadgeInProgress: 'In Progress',
        statusCompleted: 'Appointment Completed',
        statusCompletedDesc: 'Thank you for visiting us!',
        statusBadgeCompleted: 'Completed',
        statusCancelled: 'Appointment Cancelled',
        statusCancelledDesc: 'This appointment was cancelled.',
        statusBadgeCancelled: 'Cancelled',
        statusNoShow: 'No-Show',
        statusNoShowDesc: 'You did not show up for this appointment.',
        statusBadgeNoShow: 'No-Show',
        trackBooking: 'You can check your booking status anytime:',
        // Auth / Registration
        createAccount: 'Create an Account',
        createAccountDesc: 'Enter your details to book an appointment. We\'ll verify your email.',
        firstName: 'First Name',
        firstNamePlaceholder: 'John',
        lastName: 'Last Name',
        lastNamePlaceholder: 'Doe',
        sendingCode: 'Sending code…',
        verifyEmail: 'Verify Your Email',
        verifyEmailDesc: 'We sent a 4-digit code to {{email}}',
        verificationCode: 'Verification Code',
        verifying: 'Verifying…',
        verifyAndBook: 'Verify & Continue to Booking',
        didntReceiveCode: "Didn't receive the code?",
        resendCode: 'Resend Code',
        codeSent: 'A new code has been sent!',
        switchAccount: 'Switch account',
        newAccount: 'New Account',
        haveCode: 'I Have a Code',
        quickLogin: 'Quick Login',
        quickLoginDesc: 'Enter the 4-digit code you received from the shop.',
        clientCode: 'Client Code',
        loggingIn: 'Logging in...',
        loginAndBook: 'Login & Book',
        myAppointments: 'My Appointments',
        upcomingAppointments: 'Upcoming',
        pastAppointments: 'Past',
        noUpcoming: 'No upcoming appointments.',
        noPast: 'No past appointments.',
        loadMore: 'Load more',
        bookNow: 'Book Now',
    },

    // Walk-in modal (AppLayout)
    walkin: {
        title: 'Walk-in Quick Book',
        customerName: 'Client Name',
        namePlaceholder: 'e.g. John Doe',
        service: 'Service',
        selectService: 'Select service',
        barber: 'Barber',
        selectBarber: 'Select barber',
        bookNow: 'Book Now',
        button: 'Walk-in',
        collapse: 'Collapse',
        noBarbers: 'No barbers available for this service right now',
        noServices: 'No services available',
        noServicesDesc: 'Please add services before creating a walk-in booking.',
    },

    pending_requests: {
        title: '1 pending request',
        description: 'Tap confirm or decline for each',
        confirmButton: 'Confirm',
        declineButton: 'Decline',
        cancelAppointment: 'Cancel appointment',
        cancelAppointmentTitle: 'Cancel this appointment?',
        cancelAppointmentDesc: 'The customer will be notified and the slot freed. Continue?',
        cancelAppointmentConfirm: 'Yes, cancel',
        cancelAppointmentAbort: 'No, keep it',
        cancelledByShop: 'Cancelled by shop',
        // Banner above the calendar
        bannerOne: '{{count}} booking request waiting for confirmation',
        bannerOther: '{{count}} booking requests waiting for confirmation',
        review: 'Review',
        // Modal title
        modalTitleOne: '{{count}} pending request',
        modalTitleOther: '{{count}} pending requests',
    },

    // Appointment Show page
    show: {
        overview: 'Overview',
        products: 'Products',
        customerInfo: 'Client Information',
        review: 'Review',
        rating: 'Rating',
        comment: 'Comment',
        serviceDetails: 'Service Details',
        tip: 'Tip',
        payment: 'Payment',
        appointmentNotes: 'Appointment Notes',
        barberNotes: 'Barber Notes',
        noNotes: 'No notes for this appointment.',
        productsSold: 'Products Sold',
        add: 'Add',
        product: 'Product',
        selectProduct: 'Select product…',
        outOfStock: '— out of stock',
        inStock: 'in stock',
        qty: 'Qty',
        addProduct: 'Add Product',
        noProducts: 'No products added to this appointment.',
        min: 'min',
        newBookingRequest: 'New booking request',
        newBookingRequestSub: 'This appointment is waiting for your confirmation.',
    },

    // Dashboard booking link / DM templates
    dm: {
        bookingLink: 'Booking Link',
        bookingLinkDesc: 'Share this link with clients.',
        copyLink: 'Copy',
        copied: 'Copied!',
        dmTemplates: 'Quick DM Templates',
        template1: 'Book your appointment here 👇\n{url}',
        template2: 'Choose your time here 👇\n{url}',
        copy1: 'Copy Template 1',
        copy2: 'Copy Template 2',
    },
    // Auth pages
    auth: {
        signIn: 'Sign In',
        signInTitle: 'Sign In | GetFade',
        signInHeading: 'Sign in',
        signInSub: 'Enter your credentials to access your dashboard.',
        signInButton: 'Sign In',
        signingIn: 'Signing in...',
        noAccount: "Don't have an account?",
        createOne: 'Create one',
        keepSignedIn: 'Keep me signed in',
        forgot: 'Forgot?',
        welcomeBack: 'Welcome',
        welcomeBackAccent: 'back.',
        welcomeBackSub: 'Manage your shop, appointments and team — all in one place.',
        testimonialLogin: 'Saves me hours every week. My clients love being able to book online.',
        shopOwner: '— Shop Owner',
        statFree: 'Free for 3 months',
        statNoCard: 'No credit card',
        secureLogin: 'Secure login',
        register: 'Create Your Shop | GetFade',
        registerHeading: 'Create your shop',
        registerSub: 'Fill in your details to get started for free.',
        registerButton: 'Create Shop',
        creatingShop: 'Creating your shop...',
        alreadyAccount: 'Already have an account?',
        signInLink: 'Sign in',
        signUp: 'Sign up',
        shopName: 'Shop Name',
        yourName: 'Your Name',
        phone: 'Phone',
        password: 'Password',
        confirmPassword: 'Confirm',
        emailPlaceholder: 'you@example.com',
        shopNamePlaceholder: 'Classic Cuts',
        yourNamePlaceholder: 'John Smith',
        secureRegistration: 'Secure registration',
        or: 'or',
        googleSignUp: 'Sign up with Google',
        googleSignIn: 'Sign in with Google',
        appleContinue: 'Continue with Apple',
        appleConnected: 'Connected with Apple',
        googleConnected: 'Connected with Google',
        terms: 'By creating a shop, you agree to our <terms>Terms</terms> and <privacy>Privacy Policy</privacy>.',
        setUpShop: 'Set up your',
        setUpShopAccent: 'shop.',
        setUpShopSub: 'Create your account and start accepting bookings in minutes.',
        testimonialRegister: 'Set up in 5 minutes, fully running by end of day.',
        forgotTitle: 'Forgot Password | GetFade',
        forgotHeading: 'Forgot password',
        forgotSub: 'Enter your email and we\'ll send you a reset link.',
        forgotButton: 'Send Reset Link',
        sendingReset: 'Sending...',
        backToLogin: 'Back to login',
        resetTitle: 'Reset Password | GetFade',
        resetHeading: 'Reset password',
        resetSub: 'Please choose a strong, unique password.',
        resetButton: 'Update Password',
        updatingPassword: 'Updating...',
        accountEmail: 'Account Email',
        newPassword: 'New Password',
        confirmNewPassword: 'Confirm New Password',
        remembered: 'Remembered?',
        verifyTitle: 'Verify Email | GetFade',
        verifyHeading: 'Verify your email',
        verifySub: "Thanks for joining! To get started, please click the link we just sent to your inbox. If you didn't see it, we can send it again.",
        verifyButton: 'Resend Verification Email',
        sendingVerify: 'Sending...',
        verificationSent: 'A new link has been sent to your email address.',
        verificationCheckEmail: 'Check your email',
        verificationCheckEmailSub: 'We\'ve sent a verification code to your email address.',
        verificationCodeSent: 'A new verification code has been sent to your email. It will expire in 10 minutes.',
        verificationCode: 'Verification Code',
        verifyCode: 'Verify Code',
        verifyingCode: 'Verifying...',
        resendCode: 'Resend Code',
        verificationSuccess: 'Email Verified!',
        verificationSuccessSub: 'Your email has been successfully verified. You can now access the full platform.',
        goToDashboard: 'Go to Dashboard',
        notYourEmail: 'Not your email?',
        wrongEmail: 'Wrong email?',
        goBack: 'Go back',
        logOut: 'Log Out',
        confirmTitle: 'Confirm Access | GetFade',
        confirmHeading: 'Password required',
        confirmSub: 'Please confirm your password before continuing to the secure area.',
        confirmButton: 'Confirm Access',
        verifying: 'Verifying...',
        notYou: 'Not you?',
        signInDifferent: 'Sign in as different user',
    },

    // Dashboard setup checklist
    // Settings - Time ago strings
    timeAgo: {
        justNow: 'Just now',
        minAgo: '{{count}} min ago',
        hrAgo: '{{count}} hr ago',
        daysAgo: '{{count}} days ago',
    },

    // Settings - Security & Sessions
    security: {
        twoFactorTitle: 'Two-Factor Authentication',
        twoFactorDesc: 'Add an extra layer of security to your account.',
        enable2FA: 'Enable 2FA',
    },
    sessions: {
        activeSessionsDesc: 'These are all your currently active browser sessions.',
        noActiveSessions: 'No active sessions found.',
        thisDevice: 'This device',
    },
    danger: {
        deleteAccountDesc: 'Permanently delete your account and all associated data.',
    },
    deleteShop: {
        title: 'Delete Shop',
        desc: 'Deleting your shop will archive it and deactivate all services. All users will be logged out.',
        dialogTitle: 'Delete Shop',
        dialogDesc: 'Deleting your shop will archive it and deactivate all services.',
        confirmButton: 'Delete Shop',
    },

    // Update Password Form
    password: {
        updateTitle: 'Update Password',
        updateDesc: 'Use a long, random password to keep your account secure.',
        currentPassword: 'Current Password',
        newPassword: 'New Password',
        confirmNewPassword: 'Confirm New Password',
        updateButton: 'Update Password',
        saved: 'Saved.',
        verifyTitle: 'Check your email',
        verifyDesc: 'We sent a 6-digit code to your email. Enter it below to confirm your password change.',
        verificationCode: 'Verification Code',
        confirmChange: 'Confirm Change',
        didntReceive: "Didn't receive the code?",
        resend: 'Resend',
        resendIn: 'Resend code in',
    },

    // Delete Account Form
    deleteAccount: {
        title: 'Delete Account',
        desc: 'Once your account is deleted, all data will be permanently removed. This action cannot be undone.',
        dialogTitle: 'Delete Account',
        dialogDesc: 'This will permanently delete your account and all associated data. Enter your password and we\'ll email you a code to confirm.',
        shopWarning: 'If you are the only admin of your shop, the shop is deleted too — with all its bookings, clients, services and staff accounts.',
        dialogDescEmail: 'This will permanently delete your account and all associated data. We\'ll email a code to {{email}} to confirm.',
        passwordPlaceholder: 'Enter your password',
        cancelButton: 'Cancel',
        deleteButton: 'Permanently Delete',
        sendCodeButton: 'Email me a code',
        codeSent: 'We sent a 6-digit code to {{email}}. Enter it to permanently delete your account.',
        codeLabel: 'Code from the email',
        resendCode: 'Send a new code',
    },

    setup: {
        ofComplete: '{{count}} of {{total}} complete',
        title: 'Getting Started',
        done: 'done',
        shopInfoLabel: 'Fill in your shop info',
        shopInfoSub: 'Add your phone number and address',
        shopInfoLink: 'Go to Settings',
        barbersLabel: 'Add your barbers',
        barbersSub: 'Set up barber profiles and working hours',
        barbersLink: 'Add Barbers',
        servicesLabel: 'Add your services',
        servicesSub: 'Define what you offer with prices and durations',
        servicesLink: 'Add Services',
        shareLink: 'Share your booking link',
        copy: 'Copy',
        copied: 'Copied!',
    },

    // Settings
    settingsPage: {
        bookingQrDesc: 'Show this QR code in your shop. Clients scan it with the GetFade app or their camera to book.',
        bookingQrDownload: 'Download QR code',
        legalPrivacy: 'Privacy Policy', legalTerms: 'Terms of Service', legalCookies: 'Cookie Policy', legalSupport: 'Help & support',
        title: 'Settings',
        bookingLink: 'Your Booking Link',
        bookingLinkDesc: 'Share this link so clients can book online',
        copyLink: 'Copy Link',
        haircutPreview: 'Haircut Style Preview',
        haircutPreviewDesc: 'Clients scan this to try on haircut styles with AI before booking.',
        currencyUSD: 'USD — Dollar',
        currencyEUR: 'EUR — Euro',
        currencyALL: 'ALL — Lek',
        shopInfo: 'Shop Information',
        shopInfoDesc: 'Basic details about your shop visible to clients.',
        shopName: 'Shop Name',
        shopLogo: 'Shop Logo',
        shopLogoDesc: 'Shown to clients on the booking page. JPG, PNG or WebP, max 2MB.',
        languageDesc: 'Language used across the dashboard for your account.',
        uploadLogo: 'Upload Logo',
        changeLogo: 'Change Logo',
        fileTooLarge: 'File is too large. Maximum size is {{max}}.',
        invalidFileType: 'Please select an image file (JPG, PNG, WebP).',
        uploadFailed: 'Upload failed. Please try a smaller file or different format.',
        timezone: 'Timezone',
        timezonePlaceholder: 'e.g. Europe/London',
        streetAddress: 'Street Address',
        city: 'City',
        stateRegion: 'State / Region',
        zipPostal: 'ZIP / Postal Code',
        country: 'Country',
        googleMapsUrl: 'Google Maps link',
        googleMapsUrlHint: 'Open Google Maps, find your shop, tap Share → Copy link, then paste it here.',
        currency: 'Default Currency',
        notifications: 'Notifications',
        notificationsDesc: 'Control how you receive appointment notifications.',
        soundNotifications: 'Sound Notifications',
        soundNotificationsDesc: 'Play a sound when you receive a notification.',
        emailNotifications: 'Email Notifications',
        emailNotificationsDesc: 'Get notified by email when appointments are booked or updated.',
        preferencesSaved: 'Notification preferences saved',
        settingsSaved: 'Settings saved',
        virtualHaircut: 'Virtual Haircut Try-On',
        virtualHaircutDesc: 'Share this link so clients can try on haircuts with AI.',
        qrCode: 'QR Code',
        qrCodeDesc: 'Share this code with your clients for easy booking access.',
        qrCodeInfo: 'Point your phone camera at this QR code or share it on social media, your website, or anywhere else your clients might be.',
        downloadQR: 'Download QR Code',
        hairstylePreview: 'Hairstyle Preview',
        hairstylePreviewDesc: 'Share this link so clients can preview hairstyles with AI.',
        bookingLanguage: 'Booking page language',
        bookingLanguageHint: 'The language your public booking link (the page clients use) is shown in. This is separate from your dashboard language.',
        autoConfirmTitle: 'Auto-confirm bookings',
        autoConfirmDesc: 'When on, bookings on free slots are confirmed automatically — no manual approval needed. When off, every booking comes in as pending and you decide to confirm or decline.',
        requireAccountsTitle: 'Require client accounts',
        requireAccountsDesc: 'When on, clients must sign up or log in before booking. When off, your booking link goes straight to the form and clients just enter their name and phone number.',
        slotIntervalTitle: 'Booking time slots',
        slotIntervalDesc: 'How often bookings can start. 15 min = 9:00, 9:15, 9:30… 30 min = 9:00, 9:30, 10:00…',
        defaultLanguage: 'Default booking language',
        defaultLanguageHint: 'Customers will see this language by default. They can change it on their profile.',
    },

    // Notifications
    notif: {
        title: 'Notifications',
        markAllRead: 'Mark all as read',
        noNotifications: 'No notifications yet',
        view: 'View',
        markAsRead: 'Mark as read',
        showMore: 'Show more',
    },

    // Reports
    reports: {
        title: 'Reports',
        revenue: 'Revenue',
        appointments: 'Appointments',
        completed: 'Completed',
        cancelled: 'Cancelled',
        noShows: 'No-shows',
        tipsCollected: 'Tips Collected',
        byBarber: 'By Barber',
        byService: 'By Service',
        completionRate: 'Completion rate',
        avgTicket: 'Avg ticket',
        topPerformer: 'Top',
        tipsLabel: 'tips',
        apptsLabel: 'appts',
        noData: 'No data for this period.',
        export: 'Export',
        exportPdf: 'PDF',
        exportXlsx: 'Excel',
        exportCsv: 'CSV',
        dateRange: 'Date range',
        from: 'From',
        to: 'To',
        apply: 'Apply',
        reset: 'Reset',
    },

    // Admin dashboard
    admin: {
        title: 'Platform Admin',
        superAdmin: 'Super Admin',
        overview: 'Overview',
        shops: 'Shops',
        activity: 'Activity',
        platformOverview: 'Platform Overview',
        allShops: 'All Shops',
        recentActivity: 'Recent Activity',
        totalRevenue: 'Total Revenue',
        totalBookings: 'Total Bookings',
        activeShops: 'Active Shops',
        customers: 'Clients',
        bookings30d: 'Bookings · last 30 days',
        revenue6m: 'Revenue · last 6 months',
        topShops: 'Top Shops · this month',
        statusBreakdown: 'Status Breakdown',
        newShops: 'New Shops · last 7 days',
        recentBookings: 'Recent Bookings',
        viewAll: 'View all →',
        activeShopsLabel: 'Active shops',
        todayBookings: "Today's bookings",
        cancelRate: 'Cancel rate',
        live: 'Live',
        noData: 'No data yet.',
        noActivity: 'No activity yet.',
        noNewShops: 'No new shops this week.',
        last30: 'Last 30',
        vsLastMonth: '% vs last month',
        signOut: 'Sign out',
        joined: 'Joined',
        booked: 'booked',
        totalLabel: 'total',
        inactiveLabel: 'inactive',
        total: 'total',
        today: 'today',
        archived: 'Archived',
        archivedShops: 'Archived Shops',
        archivedShopsCount: 'archived shops',
        noArchivedShops: 'No archived shops.',
        restore: 'Restore',
        companies: 'Companies',
        users: 'Users',
        plans: 'Plans',
        subscriptions: 'Subscriptions',
        auditLogs: 'Audit Logs',
        roles: 'Roles & Permissions',
        settings: 'Settings',
        createCompany: 'Create Company',
        editCompany: 'Edit Company',
        companyDetails: 'Company Details',
        deleteCompany: 'Delete Company',
        deleteCompanyConfirm: 'Are you sure you want to delete this company? This will soft-delete the company and all associated data.',
        forceDeleteConfirm: 'This action is permanent and cannot be undone. All company data will be lost.',
        suspendCompany: 'Suspend Company',
        activateCompany: 'Activate Company',
        impersonate: 'Login as Admin',
        stopImpersonation: 'Return to Admin',
        impersonating: 'Impersonating',
        createUser: 'Create User',
        editUser: 'Edit User',
        userDetails: 'User Details',
        deleteUser: 'Delete User',
        deleteUserConfirm: 'Are you sure you want to delete this user?',
        resetPassword: 'Reset Password',
        resetPasswordConfirm: 'Generate a new temporary password for this user?',
        assignRole: 'Assign Role',
        createPlan: 'Create Plan',
        editPlan: 'Edit Plan',
        deletePlan: 'Delete Plan',
        deletePlanConfirm: 'Are you sure you want to delete this plan?',
        assignPlan: 'Assign Plan',
        changePlan: 'Change Plan',
        cancelSubscription: 'Cancel Subscription',
        allCompanies: 'All Companies',
        activeOnly: 'Active Only',
        inactiveOnly: 'Inactive Only',
        allUsers: 'All Users',
        allRoles: 'All Roles',
        allStatuses: 'All Statuses',
        search: 'Search...',
        noResults: 'No results found.',
        actions: 'Actions',
        status: 'Status',
        role: 'Role',
        company: 'Company',
        email: 'Email',
        phone: 'Phone',
        name: 'Name',
        createdAt: 'Created',
        barbers: 'Barbers',
        services: 'Services',
        appointments: 'Appointments',
        revenue: 'Revenue',
        lastBooking: 'Last Booking',
        unlimited: 'Unlimited',
        perMonth: '/mo',
        perYear: '/yr',
        free: 'Free',
        trial: 'Trial',
        active: 'Active',
        inactive: 'Inactive',
        pastDue: 'Past Due',
        cancelled: 'Cancelled',
        expired: 'Expired',
        save: 'Save',
        saving: 'Saving...',
        confirm: 'Confirm',
        permanentDelete: 'Delete Permanently',
        editPermissions: 'Edit Permissions',
        permissionsCount: 'Permissions',
        rolesCount: 'roles',
        all: 'All',
        allPermissionsLocked: 'All permissions (locked)',
        permissionMatrix: 'Permission Matrix',
        permission: 'Permission',
        cancel: 'Cancel',
        more: 'more',
        viewUsers: 'View Users',
        general: 'General',
        security: 'Security',
        features: 'Features',
        maintenance: 'Maintenance',
        maintenanceMode: 'Maintenance Mode',
        maintenanceModeDesc: 'Enable maintenance mode to temporarily disable the platform.',
        appName: 'Application Name',
        defaultTimezone: 'Default Timezone',
        supportEmail: 'Support Email',
        registrationEnabled: 'Registration Enabled',
        requireEmailVerification: 'Require Email Verification',
    },

    // Landing page
    land: {
        // Navbar
        navHowItWorks: 'How it works',
        navFeatures: 'What You Get',
        navPricing: 'Pricing',
        navSupport: 'Questions?',
        navLogin: 'Login',
        navBook: 'Book Appointment',
        // Hero
        heroHeading: 'Stop juggling appointments on paper',
        heroSub: 'Bookings, schedules, reminders, and payments — all in one place. No more missed appointments. No more manual work.',
        heroBtn: 'Start Free Today',
        heroBtn2: 'See How It Works',
        // Problem & Solution
        problemLabel: 'Your Problems',
        problemHeading: 'Running a barbershop is stressful',
        problemSub: 'Double bookings, clients who forget their appointments, no idea if you\'re actually making money. Sound familiar?',
        problem1: 'Double bookings and chaos',
        problem2: 'Inventory nightmare',
        problem3: 'Clients go silent',
        problem4: 'Team doesn\'t know what\'s going on',
        solutionLabel: 'Our Solution',
        solutionHeading: 'How It Works',
        solutionSub: 'One place for everything. Smart scheduling, automatic reminders, real money tracking.',
        solution1: 'Smart booking system',
        solution2: 'No more double bookings',
        solution3: 'Keep clients happy',
        solution4: 'Your team stays on the same page',
        // Features
        featuresLabel: 'What You Get',
        featuresHeading: 'Everything built for real barbershops',
        featuresSub: 'Simple tools that actually work. Made by people who get it.',
        feature1Title: 'Online booking that actually works',
        feature1Desc: 'Clients book online, your schedule updates automatically. No more double bookings ever.',
        feature2Title: 'Manage your barbers',
        feature2Desc: 'See who\'s working when, track time off, and who\'s the best at what.',
        feature3Title: 'Know your numbers',
        feature3Desc: 'See how much you\'re making, what services are popular, and where the money comes from.',
        feature4Title: 'Custom services and prices',
        feature4Desc: 'Set up your cuts, colors, and whatever else you offer with your own prices.',
        feature5Title: 'Your clients book 24/7',
        feature5Desc: 'Share a link with your clients. They book anytime they want, even at 2am.',
        feature6Title: 'Works in English, German, Albanian',
        feature6Desc: 'Your clients can book in the language they speak.',
        // Feature cards (grid section)
        featureCardMobileTitle: 'Mobile-First Booking',
        featureCardMobileDesc: 'Beautiful, fast booking experience on any device. Clients book in seconds.',
        featureCardRemindersTitle: 'Smart Reminders',
        featureCardRemindersDesc: 'Automatic email reminders reduce no-shows and keep clients informed.',
        featureCardAnalyticsTitle: 'Business Analytics',
        featureCardAnalyticsDesc: 'Track revenue, popular services, client trends, and growth metrics easily.',
        featureCardCollabTitle: 'Team Collaboration',
        featureCardCollabDesc: 'Share schedules, notes, and client info with your entire team in real-time.',
        featureCardSecureTitle: 'Secure & Reliable',
        featureCardSecureDesc: 'Bank-level security with encrypted data. 99.9% uptime guarantee.',
        featureCardFastTitle: 'Lightning Fast',
        featureCardFastDesc: 'Optimized for speed. Pages load instantly, even on slow connections.',
        // Stats
        statsLabel: 'Real Results from Real Barbers',
        stat1Value: '+45%',
        stat1Label: 'More bookings',
        stat2Value: '-70%',
        stat2Label: 'Fewer no-shows',
        stat3Value: '3+ Hours',
        stat3Label: 'Saved daily',
        stat4Value: '+$5K',
        stat4Label: 'Monthly revenue',
        // Testimonials
        testimonialsTitle: 'Trusted by Barbers Worldwide',
        testimonialsSub: 'Barbers using GetFade are saving time, increasing bookings, and growing their business.',
        // Pricing
        pricingLabel: 'Pricing',
        pricingHeading: 'Simple, Transparent Pricing',
        pricingSub: '',
        pricingDesc: 'One simple plan for every shop: free for 3 months, then €10 a month. No credit card needed to start, cancel anytime.',
        pricingTrialDesc: 'Start your 3-month free trial with no credit card required.',
        planStarterName: 'Solo',
        planStarterPrice: 'Free',
        planStarterPer: 'forever',
        planStarterDesc: 'Perfect if you\'re just starting out.',
        planStarterFeature1: '1 shop',
        planStarterFeature2: 'Up to 3 barbers',
        planStarterFeature3: 'Online booking',
        planStarterFeature4: 'Basic dashboard',
        planProName: 'Shop',
        planProPrice: '$29',
        planProPer: '/month',
        planProDesc: 'For shops that are growing fast.',
        planProBadge: 'Most People Pick This',
        planProFeature1: 'Unlimited barbers',
        planProFeature2: 'See your numbers',
        planProFeature3: 'Keep clients happy',
        planProFeature4: 'Priority help',
        planEnterpriseName: 'Chain',
        planEnterprisePrice: 'Let\'s talk',
        planEnterpriseDesc: 'For bigger operations.',
        planEnterpriseFeature1: 'Multiple shops',
        planEnterpriseFeature2: 'Everything custom',
        planEnterpriseFeature3: 'Dedicated team',
        planCTA: 'Try it now',
        planContactUs: 'Get in touch',
        // Pricing Plans (new names)
        planName1: 'Starter',
        planPrice1: 'Free',
        planDesc1: 'Perfect for solo barbers starting their business',
        planFeature1_1: 'Online booking page',
        planFeature1_2: '1 shop location',
        planFeature1_3: 'Up to 3 barbers',
        planFeature1_4: 'Simple dashboard to manage appointments',
        planName2: 'Pro',
        planPrice2: '€10/mo',
        planDesc2: 'For barbers who want to grow faster and stay fully booked',
        planBadge2: '3 months free',
        planSubtext2: 'Earn back your subscription with just 1 extra client',
        pricingFact1: "for your first 3 months",
        pricingFact2: "a month after that",
        pricingFact3: "commission on bookings",
        planFeature2_1: 'Everything in Starter',
        planFeature2_2: 'Unlimited barbers & team access',
        planFeature2_3: 'Automatic email reminders (reduce no-shows)',
        planFeature2_4: 'Track revenue & performance in real-time',
        planFeature2_5: 'Manage your entire team from one dashboard',
        planName3: 'Enterprise',
        planPrice3: 'Custom',
        planDesc3: 'For multi-location barbershops and growing chains',
        planFeature3_1: 'Multiple locations management',
        planFeature3_2: 'Centralized dashboard across all shops',
        planFeature3_3: 'Custom integrations',
        planFeature3_4: 'API access',
        planFeature3_5: 'Priority support',
        // Comparison
        comparisonHeading: 'Why GetFade Beats the Paper + Chaos Method',
        comparisonSub: 'See how GetFade compares to traditional barbershop management',
        comparisonLabel: 'Feature',
        comparisonTraditional: 'Traditional (Paper, Phone, etc)',
        comparisonFade: 'GetFade',
        comparisonFeature1: 'Online Booking',
        comparisonFeature1Traditional: 'Clients call to book — you miss calls all the time',
        comparisonFeature1Fade: 'Clients book 24/7 online — you never miss an appointment',
        comparisonFeature2: 'Revenue Tracking',
        comparisonFeature2Traditional: 'Count cash at end of day — no insight into trends',
        comparisonFeature2Fade: 'Revenue by day, barber and service — with trends',
        comparisonFeature3: 'Client History',
        comparisonFeature3Traditional: 'Notes scattered everywhere — no consistency',
        comparisonFeature3Fade: 'Visits, no-shows and favourite barber for every client',
        comparisonFeature4: 'Multi-Barber Coordination',
        comparisonFeature4Traditional: 'Everyone works independently — impossible to scale',
        comparisonFeature4Fade: 'Working hours, time off and every barber\'s schedule in one place',
        comparisonFeature5: 'Business Growth',
        comparisonFeature5Traditional: 'Capped by time and energy, hard to expand',
        comparisonFeature5Fade: 'Handle 2-3x more bookings without chaos',
        // Hero Benefits Text
        heroBenefits: 'Set up in minutes • No technical skills needed • Built for real barbers',
        // How It Works Steps
        step1Title: 'Set Up Your Shop',
        step1Desc: 'Add services, staff, and availability in just a few minutes.',
        step2Title: 'Share Your Booking Link',
        step2Desc: 'Let clients book directly through a link on Instagram, WhatsApp, or your website.',
        step3Title: 'Manage Everything Automatically',
        step3Desc: 'Appointments, reminders, and schedules handled for you — no calls, no stress.',
        // Smart Scheduling Section
        smartSchedulingTitle: 'Stay Fully Booked — Without Overbooking',
        smartSchedulingDesc: 'Smart scheduling fills your day efficiently while preventing gaps, overlaps, and missed opportunities.',
        smartSchedulingFeature1: 'Smart Calendar',
        smartSchedulingFeature1Desc: 'See your full schedule in one place and manage bookings instantly.',
        smartSchedulingFeature2: 'Time Optimization',
        smartSchedulingFeature2Desc: 'Reduce gaps between appointments and maximize your daily capacity.',
        smartSchedulingFeature3: 'Team Coordination',
        smartSchedulingFeature3Desc: 'Manage multiple barbers and keep everyone aligned effortlessly.',
        // Footer additions
        colSupport: 'Support',
        linkPricing: 'Pricing',
        linkDemo: 'Demo',
        linkHelp: 'Help Center',
        linkContact: 'Contact',
        // Hero Section (new for redesign)
        heroLabel: 'Barbershop Management, Simplified',
        heroTitle: 'Everything You Need to Run Your Barbershop — In One System',
        heroTrust: 'barbershops using GetFade',
        heroRating: 'from 2,000+ reviews',
        // Features Section (new for redesign)
        featuresFeature1: 'Smart Scheduling',
        featuresDesc1: 'Automated appointment booking with real-time availability and instant client confirmations.',
        featuresFeature2: 'Team Management',
        featuresDesc2: 'Manage barbers, assign services, set schedules, and track performance in one place.',
        featuresFeature3: 'Revenue Tracking',
        featuresDesc3: 'Real-time insights on earnings, popular services, and business growth metrics.',
        featuresFeature4: 'Client Profiles',
        featuresDesc4: 'Store preferences, service history, and notes for every client.',
        // Stats Section (new for redesign)
        statsBarbershops: 'barbershops growing with GetFade',
        statsAppointments: 'appointments booked monthly',
        statsRevenue: 'revenue processed',
        statsSupport: 'support when you need it',
        // CTA Section (new for redesign)
        ctaTitle: 'Ready to transform your barbershop?',
        ctaSub: 'Join thousands of barbershops already using GetFade to book more appointments and earn more revenue.',
        // Lock in Loyalty
        retentionLabel: 'Growth',
        loyaltyHeading: 'Grow your\nclient base',
        loyaltySub: 'Provide clients with an easy-to-use booking experience. Reduce no-shows, increase loyalty, and build a strong client base with your dedicated booking page.',
        loyaltyBtn: 'Enable Booking',
        // Features Showcase (section 2)
        showcaseLabel: 'Powerful Features',
        showcaseTitle: 'Everything you need to run your shop',
        showcaseSub: 'Manage your shop operations efficiently so you can focus on great cuts.',
        showcaseFeature1Title: 'Smart Booking',
        showcaseFeature1Desc: 'Automated scheduling with instant confirmations, reminders, and no-show reduction',
        showcaseFeature2Title: 'Client Profiles',
        showcaseFeature2Desc: 'Store preferences, notes, and service history for every regular client',
        showcaseFeature3Title: 'Team Management',
        showcaseFeature3Desc: 'Assign barbers, track individual schedules, and manage workload distribution',
        showcaseFeature4Title: 'Analytics & Reports',
        showcaseFeature4Desc: 'Real-time insights on revenue, appointments, client trends, and more',
        showcaseFeature5Title: 'Client Portal',
        showcaseFeature5Desc: 'Shareable booking link for easy client booking, anywhere, anytime',
        showcaseFeature6Title: 'Performance Tracking',
        showcaseFeature6Desc: 'Monitor barber performance, ratings, and service completion metrics',
        // Barbers & Clients
        forLabel: 'For',
        barbersTitle: 'Barber Shops',
        businessTitle: 'Barbers',
        barbersSub: 'Take control of your schedule, clients, revenue, and brand.',
        findOutHow: 'Learn more',
        // Shop Stories
        testimonialsLabel: 'Success Stories',
        shopStoriesTitle: 'Barber success stories',
        shopStoriesSub: 'Real barbershops, real growth.',
        // Get Free
        startTodayLabel: 'Start Free Today',
        getFreeTitle: 'Start managing\nyour barbershop',
        getFreeSub: 'Set up in minutes. No credit card required. Start accepting online bookings and managing your team today.',
        getFreeBtn: 'Get Started Free',
        // FAQ
        faqLabel: 'Questions?',
        faqTitle: 'Frequently asked questions',
        faqSub: 'Everything you need to know about GetFade.',
        faqQ1: 'How do I get started with GetFade?',
        faqA1: 'Getting started is simple! Sign up for a free account, set your services and prices, add your barbers, and start accepting online bookings. Most barbershops are up and running in less than 10 minutes.',
        faqQ2: 'Is there a setup fee or credit card required?',
        faqA2: "No. There is no setup fee and no credit card needed to start. You get the full product free for 3 months, then it's €10 a month.",
        faqQ3: 'Can I manage multiple locations?',
        faqA3: 'Currently, each GetFade account manages one barbershop. If you have multiple locations, you can create separate accounts for each shop and manage them independently.',
        faqQ4: 'How do my clients book appointments?',
        faqA4: 'Your clients can book online through a simple, mobile-friendly booking page. They choose a service, select a barber, pick a time, and confirm. You\'ll get notified instantly, and they receive a confirmation.',
        faqQ5: 'Can clients cancel or reschedule their appointments?',
        faqA5: 'Yes! Clients can cancel or reschedule through their booking link before the appointment. You can also manage cancellations and reschedules from your dashboard.',
        faqQ6: "What happens when the 3 free months end?",
        faqA6: "Nothing is charged automatically, because we never asked for your card. To keep using GetFade you continue on the €10 a month plan. If you don't, your dashboard, the app and your booking page switch off until you do, and your data stays safe.",
        faqQ7: "Do you take a cut of my bookings?",
        faqA7: "No. You pay a flat €10 a month, whether you take 20 bookings or 2,000. What you charge your clients is yours to keep, with no commission and no per-booking fees.",
        // Footer
        footerTagline: 'The complete management system for barbershops. Simple, powerful, and reliable.',
        colProduct: 'Product',
        colCompany: 'Company',
        colResources: 'Resources',
        colLegal: 'Legal',
        linkHowItWorks: 'How it works',
        linkStories: 'Stories',
        linkGetStarted: 'Get started',
        linkAbout: 'About',
        linkBlog: 'Blog',
        linkCareers: 'Careers',
        linkPrivacy: 'Privacy',
        linkTerms: 'Terms',
        linkSecurity: 'Security',
        linkCookies: 'Cookies',
        supportLabel: 'Support',
        supportTitle: 'Need help?',
        supportSub: 'Send us a message and our team will respond promptly.',
        supportPlaceholder: 'your@email.com',
        supportBtn: 'Send',
        supportSent: "We got your message — we'll be in touch soon.",
        copyright: '© 2026 GetFade. All rights reserved.',
        builtBy: 'Built for barbers, by barbers.',
        madeBy: 'Made by',
        // an2tech section
        an2techLabel: 'The team behind this',
        an2techHeading: 'Want a product like this\nbuilt for your business?',
        an2techSub: 'an2tech builds modern web apps, SaaS platforms, and digital tools — fast, clean, and production-ready.',
        an2techBtn: 'Work with us',
        an2techTagline: 'Design · Development · Launch',
        // Cookie banner
        cookieText: 'We only use essential cookies to keep you signed in. Optional cookies would only ever be used if you accept them.',
        cookieAccept: 'Accept',
        cookieDecline: 'Decline',
        cookieLearnMore: 'Learn more',
    },

    // Appointments Index extras
    apptIndex: {
        appointments: 'Appointments',
        fullyBooked: 'Fully booked',
        selected: '{{count}} selected',
        confirmAll: 'Confirm all',
        cancelAll: 'Cancel all',
        clear: 'Clear',
        confirmApptTooltip: 'Confirm appointment',
        namePlaceholder: 'John Doe',
        phonePlaceholder: '+1 555 000-0000',
        minLabel: 'min',
        nowLabel: 'Now',
        searchPlaceholder: 'Search by name, barber, or service…',
        filterStatusAll: 'All statuses',
        filterDateAll: 'All dates',
        filterDateLast7d: 'Last 7 days',
        filterDateLast30d: 'Last 30 days',
        filterDateLast90d: 'Last 90 days',
        calendar: 'Calendar',
        list: 'List',
        kanban: 'Kanban',
    },

    // Toast notifications
    toast: {
        notificationsMarkedAsRead: 'All notifications marked as read',
        walkinBooked: 'Walk-in booked for {{name}}.',
        goalsUpdated: 'Goals updated.',
        sponsorAdded: 'Sponsor added.',
        sponsorUpdated: 'Sponsor updated.',
        sponsorRemoved: 'Sponsor removed.',
        serviceCreated: 'Service created.',
        serviceUpdated: 'Service updated.',
        serviceDeleted: 'Service deleted.',
        newBooking: 'New booking received!',
        newBookingFrom: 'New booking from {{name}}',
        aCustomer: 'A customer',
        autoConfirmedFrom: 'New booking auto-confirmed: {{name}}',
        autoConfirmedEyebrow: 'New booking · Auto-confirmed',
        bookingConfirmed: 'Booking confirmed',
        bookingDeclined: 'Booking declined',
        customerCreated: 'Client added successfully.',
        customerDeleted: 'Client deleted.',
        appointmentCreated: 'Appointment created.',
        appointmentUpdated: 'Appointment updated.',
        appointmentConfirmed: 'Appointment confirmed.',
        appointmentDeclined: 'Appointment declined.',
        appointmentCancelledByStaff: 'Appointment cancelled.',
        appointmentStatusUpdated: 'Appointment status updated.',
        appointmentDeleted: 'Appointment deleted.',
        barberCreated: 'Barber created.',
        barberUpdated: 'Barber updated.',
        barberDeleted: 'Barber deleted.',
        barberAvailable: 'Barber is now available.',
        barberUnavailable: 'Barber marked unavailable for today.',
        scheduleUpdated: 'Schedule updated.',
        timeOffAdded: 'Time off added.',
        timeOffRemoved: 'Time off removed.',
        shopActivated: 'Shop activated.',
        shopDeactivated: 'Shop deactivated.',
        shopRestored: 'Shop restored successfully.',
        shopPermanentlyDeleted: 'Shop permanently deleted.',
        productCreated: 'Product created.',
        productUpdated: 'Product updated.',
        productDeleted: 'Product deleted.',
        haircutCreated: 'Haircut created.',
        haircutUpdated: 'Haircut updated.',
        haircutDeleted: 'Haircut deleted.',
        passwordReset: 'Password has been reset successfully.',
    },
    dialogs: {
        confirmDeleteTimeOff: 'Are you sure you want to remove this time off?',
        confirmDeleteAd: 'Delete this ad?',
        confirmCancelAppointment: 'Cancel this appointment?',
    },

    // Virtual Haircut
    virtualHaircut: {
        pageTitle: 'Virtual Haircut Try-On',
        pageDescription: 'Choose a style on the left, see the preview on the right',
        chooseYourStyle: 'Choose Your Style',
        chooseYourStyleDesc: 'Select a haircut to see how it looks with your photo',
        chooseStyleFirst: 'Choose a style first',
        chooseStyleFirstDesc: 'Select a haircut style from the left, then open your camera to try it on.',
        yourPhoto: 'Your Photo',
        yourPhotoDesc: 'Take a selfie to get started',
        readyToTryOn: 'Ready to try-on?',
        readyToTryOnDesc: 'Take a selfie to see how different haircut styles look on you',
        openCamera: 'Open Camera',
        cameraPermissionRequired: 'Camera Permission Required',
        allowCameraAccess: 'Allow camera access in your browser settings',
        aiPreview: 'AI Preview',
        generatingPreview: 'Generating preview...',
        upTo30Seconds: 'Up to 30 seconds',
        retakePhoto: 'Retake Photo',
        bookThisHaircut: 'Book This Haircut',
        proTips: 'Pro tips',
        goodLighting: 'Good lighting helps with accuracy',
        faceCameraDirectly: 'Face the camera directly',
        tryAllStyles: 'Try all styles before booking',
        howItWorks: 'How it works',
        helpStep1Title: 'Choose a hairstyle',
        helpStep1Desc: 'Browse the styles on the right and tap the one you want to try.',
        helpStep2Title: 'Take a selfie',
        helpStep2Desc: 'Use the camera or upload a photo. Face forward with good lighting.',
        helpStep3Title: 'See your preview',
        helpStep3Desc: 'AI generates a preview of you with the selected haircut. Try as many styles as you want!',
        gotIt: 'Got it',
        uploadPhoto: 'Upload photo instead',
        generatePreview: 'Generate Preview',
        serviceUnavailable: 'This feature is temporarily unavailable. Please try again later.',
        updatingTitle: 'We\'re improving this feature',
        updatingDesc: 'Please try again in a moment — we\'re making things better for you.',
        openingCamera: 'Opening camera...',
        before: 'Before',
        after: 'After',
        tryAnotherStyle: 'Try another style',
        hairColor: 'Hair color',
        colors: {
            natural: 'Natural',
            black: 'Black',
            darkBrown: 'Brown',
            blonde: 'Blonde',
        },
    },

    notifications: {
        title: 'Notifications',
        newBookings: 'New bookings',
        today: "Today's appointments",
        empty: 'No appointments today',
        upcoming: 'You have {{count}} upcoming',
        upcomingWithTime: 'You have {{count}} upcoming — first at {{time}}',
        tomorrow: 'You have {{count}} booked for tomorrow',
        tomorrowWithTime: 'You have {{count}} booked for tomorrow — first at {{time}}',
        allClearTitle: 'All clear',
        allClearBody: 'No appointments today or tomorrow.',
        seeAll: 'See all',
        unread: 'unread',
        summary: {
            total: 'Total today',
            inProgress: 'In progress',
            completed: 'Completed',
            next: 'Next up',
            now: 'Now',
            inMinutes: 'in {{m}} min',
            inHours: 'in {{h}}h {{m}}m',
        },
    },

    bookingAuth: {
        keepSignedIn: "Keep me signed in",
        verifyTitle: "Confirm your email",
        verifySub: "We sent a 6-digit code to {{email}}. Enter it below to finish setting up your account.",
        verifyCodeLabel: "Verification code",
        verifyBtn: "Confirm email",
        verifying: "Confirming…",
        verifyResend: "Didn't get it? Send a new code",
        verifyResent: "A new code is on its way.",
        verifySending: "Sending…",
        forgotTitle: "Forgot your password?",
        forgotSub: "Enter your email and we'll send you a link to set a new one.",
        sendResetLink: "Send reset link",
        sending: "Sending…",
        backToSignIn: "Back to sign in",
        resetTitle: "Set a new password",
        googleContinue: "Continue with Google",
        orDivider: "or",
        forgotPassword: "Forgot password?",
        signUp: 'Sign up',
        signIn: 'Sign in',
        eyebrow: 'Book an appointment',
        tagline: 'Premium grooming',
        firstName: 'First name',
        firstNamePlaceholder: 'John',
        lastName: 'Last name',
        lastNamePlaceholder: 'Doe',
        phone: 'Phone number',
        password: 'Password',
        passwordPlaceholder: 'At least 6 characters',
        confirmPassword: 'Confirm password',
        confirmPlaceholder: 'Repeat your password',
        passwordsNoMatch: 'Passwords do not match',
        email: 'Email',
        emailPlaceholder: 'you@example.com',
        contactRequired: 'At least a phone number or email is required.',
        createAccount: 'Create account',
        creatingAccount: 'Creating account…',
        terms: "By continuing, you agree to {{shop}}'s terms.",
        identifierLabel: 'Phone number or email',
        identifierPlaceholder: 'Phone or email',
        identifierHint: 'Enter the phone number or email you registered with.',
        continueBtn: 'Continue',
        checking: 'Checking…',
        passwordYour: 'Your password',
        signInBtn: 'Sign in',
        signingIn: 'Signing in…',
        welcomeBack: 'Welcome back, {{name}}',
        errNoAccount: 'No account found. Please sign up instead.',
        errEmailMismatch: 'The email does not match the account registered with this phone number.',
        errSomethingWrong: 'Something went wrong. Please try again.',
        forcePasswordTitle: 'Set a new password',
        forcePasswordIntro: 'Your account was created by your barber. Set a new password that only you know to secure it.',
        newPassword: 'New password',
        savePassword: 'Save password',
        savingPassword: 'Saving…',
    },

    welcome: {
        metaTitle: 'Booking software for barbershops',
        navFeatures: 'Features',
        navHow: 'How it works',
        navModules: 'Modules',
        navPricing: 'Pricing',
        navSignIn: 'Sign in',
        navBook: 'Book a cut',
        heroEyebrow: 'For barbers and the people who trust them',
        heroTitle: 'Book your barber.',
        heroTitleAccent: 'in three taps.',
        heroBigLine1: 'Booking,',
        heroBigLine2: 'tap, walk in',
        heroBigLine3: 'fresh.',
        heroPill: 'Booking, redesigned for barbershops',
        heroSub: 'GetFade handles bookings, clients, schedules and your barbershop — so you can focus on the cut.',
        heroSubMuted: 'No DMs. No double-booking. No surprise prices.',
        heroBadgeBooked: 'Booked',
        heroBadgeRevenue: '+€280 today',
        tickerLabel: 'Trusted by independent shops across Europe',
        directoryBadge: 'Coming soon',
        directoryEyebrow: 'Find barbers near you',
        directoryHeadline: 'Here will be listed all the barbers from different cities — each with their own unique link.',
        directoryIntro: 'Browse barbers by city. Filter by style, price, and availability. Book the cut you actually want — wherever you are.',
        directoryCityLabel: 'City {{num}}',
        directoryCityTabsLabel: 'Cities',
        directoryExplainTitle: 'Every barber, in every city.',
        directoryExplainBody: 'Pick a city and browse every barber working there — see their styles, prices, and open slots, then book in a tap.',
        howIntro: "The whole flow, end to end, in less time than it takes to wash a comb.",
        howStepBigEnding: 'barber.',
        featuresIntro: "Calendar, clients, deposits, reminders, reports. One quiet system, end of story.",
        featuresEnding: "Nothing it doesn't.",
        featLabelCalendar: 'Calendar',
        featLabelClients: 'Clients',
        featLabelReminders: 'Reminders',
        featLabelReports: 'Reports',
        featCalMonth: 'April',
        featCalYear: '2026',
        featNotifyNew: 'New booking · 11:00',
        featNotifyNewSub: 'Marco · Skin fade',
        featNotifyReminder: 'Reminder sent · 14:30',
        featNotifyReminderSub: 'James · Cut + beard',
        featRevenueLabel: 'This month',
        featRevenueAmount: '€4,280',
        featRevenueDelta: '+24%',
        clientName1: 'Marco Rossi',
        clientVisits1: '12 visits',
        clientLast1: '3d ago',
        clientName2: 'James Chen',
        clientVisits2: '8 visits',
        clientLast2: '1w ago',
        clientName3: 'Aiden Park',
        clientVisits3: '24 visits',
        clientLast3: 'today',
        previewWeekday: 'Wednesday',
        previewDate: 'April 29',
        previewBooked: '6 booked · 2 open',
        previewSideToday: 'Today',
        previewSideCalendar: 'Calendar',
        previewSideClients: 'Clients',
        previewSideServices: 'Services',
        previewSideReports: 'Reports',
        previewSvcSkinFade: 'Skin fade',
        previewSvcCutBeard: 'Cut + beard',
        previewSvcShave: 'Hot towel shave',
        previewSvcOpen: 'Open slot',
        previewNow: 'Now',
        previewAdd: '+ Add',
        quoteText: 'We replaced four tools with Getfade.',
        quoteHighlight: '30 more cuts',
        quoteAfter: 'a week.',
        quoteAuthor: 'Marco Folsom',
        quoteAuthorMeta: 'Folsom & Sons · London',
        pricePopular: '★ Popular',
        finalLine1: 'Your next cut is',
        finalTaps: 'two taps',
        finalLine2: 'away.',
        pricingHeadline1: 'One price.',
        pricingHeadline2: 'No commission.',
        pricingIntro: "What you charge is what you keep. We don't take a cut of the cut.",
        heroBook: 'Book a cut',
        heroForShops: 'For barbershops',
        previewTabBook: 'Book',
        previewTabShops: 'Shops',
        previewTabMy: 'My cuts',
        previewLocation: 'Mission · SF',
        previewShopName: 'Folsom & Sons',
        previewShopMeta: '12 min walk · ★ 4.9 (412)',
        previewService: 'Service',
        previewWhen: 'When',
        previewAvailable: 'Available times',
        previewConfirm: 'Confirm',
        previewSummary: 'Tue 28 · 11:00 · 60 min · $65',
        howEyebrow: 'How it works',
        howTitle: 'Three steps,',
        howTitleAccent: 'find your barber.',
        howTitleAccentLead: 'find your',
        howStep1Title: 'Find your barber',
        howStep1Body: 'Search by neighborhood, style, or barber. See real cuts, real prices, real reviews — nothing inflated.',
        howStep2Title: 'Lock the slot',
        howStep2Body: 'Pick the service, pick the time, hold it with a small deposit. Reschedule up to two hours out.',
        howStep3Title: 'Walk out fresh',
        howStep3Body: 'Tap to tip, rate the cut, rebook in one tap. Your barber gets the next regular.',
        featuresEyebrow: 'For shops',
        featuresTitle: 'Everything a shop needs.',
        featuresTitleAccent: "Nothing it doesn't.",
        feat1Title: 'Real-time chair calendar',
        feat1Body: 'Every chair, every barber, every slot in one calm view. Drag to rebook, tap to walk-in, never double-book.',
        feat2Title: 'Deposits that stick',
        feat2Body: 'Take a deposit at booking, refund instantly on cancel, keep it on a no-show. Your rules, your shop.',
        feat3Title: 'Client memory',
        feat3Body: 'Notes on the cut, the kid, the wedding next week. Auto-saved. Nothing slips between visits.',
        feat4Title: 'Owner dashboard',
        feat4Body: 'Daily revenue, retention, tip splits, no-show rate. The numbers your accountant asks for, ready.',
        pricingEyebrow: 'Pricing',
        pricingTitle: 'Simple.',
        pricingTitleAccent: 'Per shop.',
        priceFreeTag: 'Trial',
        priceFreeTitle: 'Free for 3 months',
        priceFreeDesc: 'Try every feature with no credit card.',
        priceFreeAmount: '€0',
        priceFreePer: 'for 3 months',
        priceFreeFeat1: 'Full access to all features',
        priceFreeFeat2: 'Unlimited bookings',
        priceFreeFeat3: 'No credit card required',
        priceFreeFeat4: 'Cancel any time',
        priceFreeCta: 'Start free trial',
        pricePaidTag: 'Pro',
        pricePaidTitle: 'Everything, no limits',
        pricePaidDesc: 'For barbers and shops who are ready to grow.',
        pricePaidAmount: '€10',
        pricePaidPer: '/ month',
        pricePaidYearNote: 'or €100 / year — save €20',
        pricePaidFeat1: 'Real-time chair calendar',
        pricePaidFeat2: 'Owner dashboard & reports',
        pricePaidFeat3: 'SMS reminders',
        pricePaidFeat4: 'Client memory & notes',
        pricePaidFeat5: 'Priority support',
        pricePaidCta: 'Get started',
        finalTitle: 'Your next cut is',
        finalTitleAccent: 'two taps away.',
        finalSub: 'Stop texting your barber. Start booking them.',
        finalCtaList: 'List your shop',
        footerTerms: 'Terms',
        footerPrivacy: 'Privacy',
        footerContact: 'Contact',
        footerRights: 'All rights reserved.',
        footerMadeBy: 'Made by',
        footerTagline: 'Booking software built for independent barbershops.',
        appsHeading: 'Mobile apps',
        appsComingSoon: 'Coming soon',
        appsAppStore: 'App Store',
        appsGooglePlay: 'Google Play',
        appsDownloadOn: 'Download on the',
        appsGetItOn: 'Get it on',
        footerProduct: 'Product',
        footerCompany: 'Company',
        footerLegal: 'Legal',
        navForBarbers: 'For Barbers',
        navResources: 'Resources',
        navStart: 'Start for free',
        heroLine1: 'Your chair.',
        heroLine2: 'Fully booked.',
        heroCta: 'Start for free',
        heroCtaAlt: 'See how it works',
        heroNote1: 'No credit card required',
        heroNote2: '3 months free',
        heroNote3: 'Setup in minutes',
        devDate: 'Tomorrow',
        devToday: 'Today',
        devNew: 'New Booking',
        devCollected: 'collected this week',
        devBookingsWeek: 'bookings this week',
        proofHead: 'Built for barbers who hate managing DMs.',
        proofTrusted: 'Trusted by 100+ barbershops worldwide',
        flowTitle1: 'Easy for your clients.',
        flowTitle2: 'More time for you.',
        flowStep1: 'Choose barber',
        flowStep2: 'Choose service',
        flowStep3: 'Pick time',
        flowStep4: 'Booking confirmed',
        flowStep1Body: 'Clients open your booking link and pick who they want.',
        flowStep2Body: 'Services, durations and prices, all clear up front.',
        flowStep3Body: 'Only real free slots show, so nothing gets double-booked.',
        flowStep4Body: 'The booking lands in your calendar straight away.',
        flowNote: 'Your own GetFade link. Works on any phone, any time.',
        phChooseBarber: 'Choose your barber',
        phSelectService: 'Select service',
        phPickTime: 'Pick a time',
        phBookNow: 'Book now',
        phBooked: 'You\'re booked!',
        phWith: 'with',
        phAddCalendar: 'Add to calendar',
        phSeeDetails: 'See booking details',
        phDashboard: 'Dashboard',
        phBookings: 'Bookings',
        phClients: 'Clients',
        phNewBooking: 'New booking',
        barberKicker: 'For barbers',
        barberTitle1: 'Your whole day.',
        barberTitle2: 'One screen.',
        barberPoint1: 'See all bookings. Avoid double bookings.',
        barberPoint2: 'Manage walk-ins and appointments.',
        barberPoint3: 'Quick access to clients, notes and history.',
        barberPoint4: 'Keep your day organized and your chair moving.',
        barberCta: 'Explore calendar',
        toolsTitle1: 'All the tools.',
        toolsTitle2: 'All in one',
        toolsTitle3: 'place.',
        toolBookings: 'Bookings',
        toolBookingsDesc: 'Online booking that fills your calendar.',
        toolCalendar: 'Calendar',
        toolCalendarDesc: 'Real-time schedule. No more overlaps.',
        toolClients: 'Clients',
        toolClientsDesc: 'Client profiles, notes and history.',
        toolPayments: 'Payments',
        toolPaymentsDesc: 'Take payments. Track earnings.',
        toolAnalytics: 'Analytics',
        toolAnalyticsDesc: 'Understand your shop. Grow your business.',
        toolBook: 'Book',
        toolVisits: 'bookings',
        toolEarnings: 'Total earnings',
        setupTitle1: 'Up and running in',
        setupTitle2: 'three steps.',
        setupLead: 'No installation, no contract. Create your shop and take your first booking today.',
        setupCta: 'Get started free',
        setupStep1Title: 'Create your profile',
        setupStep1Body: 'Sign up, add your shop name and photo. Takes about two minutes.',
        setupStep2Title: 'Add services and hours',
        setupStep2Body: 'Set your prices, durations and working hours for every barber.',
        setupStep3Title: 'Take bookings 24/7',
        setupStep3Body: 'Share your link. Clients book themselves, you get notified instantly.',
        statsTitle1: 'More cuts.',
        statsTitle2: 'Less admin.',
        statsLead: 'GetFade helps barbershops save time, increase bookings and grow revenue.',
        statsExample: 'Illustrative example of the GetFade dashboard.',
        statRev: 'Revenue this month',
        statReturning: 'Returning clients',
        statBookings: 'Bookings this month',
        statPeak: 'Your busiest times',
        statPeakValue: "Fri – Sun",
        statVs: 'vs last month',
        appTitle1: 'Manage your shop.',
        appTitle2: 'Anywhere.',
        appPoint1: 'See today\'s schedule',
        appPoint2: 'Manage bookings',
        appPoint3: 'Add clients and notes',
        appPoint4: 'Track payments',
        appPoint5: 'Get notified instantly',
        appDownload: 'Download on the',
        appGetOn: 'Get it on',
        closeTitle1: 'Ready for your',
        closeTitle2: 'next booking?',
        closeSub: 'Create your GetFade page in minutes.',
        closeCta: 'Get started',
        closeFine: 'No credit card required.',
        footerBlurb: 'Booking software for independent barbershops.',
        footerBuilt: 'Built for barbershops.',
        footerAbout: 'About',
        footerSecurity: 'Security',
        proofStat1: 'barbershops on GetFade',
        proofFactTrial: 'months free to start',
        proofFactPrice: 'per month after that',
        proofFactBooking: 'online booking for your clients',
        proofStatBarbers: 'barbers on GetFade',
        proofStat2: 'average shop rating',
        proofStat3: 'bookings taken',
    },

    company: {
        pageTitle: 'Our story',
        heroEyebrow: 'Our story',
        heroLine1: 'Built for the craft.',
        heroLine2: 'Built for barbers.',
        heroSub: 'GetFade started in a barbershop chair. We watched barbers lose clients to missed DMs, double-booked slots, and no-shows. So we built the tool we wish existed.',

        missionEyebrow: 'Mission',
        missionTitle: 'Give every barber a fair shot',
        missionBody: "Big salon chains have software teams. Independent barbers don't. GetFade levels the playing field with professional tools that take minutes to set up and seconds to use.",

        valuesEyebrow: 'What we stand for',
        valuesTitle: 'Our values',
        value1Title: 'Speed first',
        value1Desc: "Every feature is designed to save time — yours and your clients'.",
        value2Title: 'Privacy by default',
        value2Desc: 'Client data belongs to you. We never sell it, share it, or use it for ads.',
        value3Title: 'Built for everyone',
        value3Desc: 'Barbershop culture is global, and so are we.',
        value4Title: 'Community driven',
        value4Desc: 'Real barbers shape our roadmap. Every major feature came from a customer request.',
        value5Title: 'Genuinely care',
        value5Desc: 'We answer support ourselves. Not a bot. Not a ticket queue. A person who gives a damn.',
        value6Title: 'Laser focused',
        value6Desc: 'We do one thing — barbershop management. We do it better than anyone.',

        ctaTitle1: 'Ready to',
        ctaTitle2: 'join us?',
        ctaSub: 'Start your free account today. No credit card, no contracts — just a better way to run your shop.',
        ctaButton: 'Get started free',
    },

    modules: {
        pageTitle: 'Modules & Setup',
        heroBadge: '11 modules',
        heroBadgeText: 'Everything a shop needs',
        heroLine1: 'One platform.',
        heroLine2: 'Every module.',
        heroSub: 'GetFade gives you the full operating system for a barbershop — booking, calendar, clients, payments, and growth — in one calm place.',

        booking: { title: 'Booking', desc: 'Real-time chair calendar. Customers pick a service, a barber and a slot — done in under a minute.' },
        barbers: { title: 'Barbers', desc: 'Manage your team — schedules, services per barber, time off, and per-chair commission rules.' },
        customers: { title: 'Customers', desc: 'Client memory: notes on the cut, the kid, the wedding next week. Auto-saved between visits.' },
        appointments: { title: 'Appointments', desc: 'Daily view, drag-to-reschedule, walk-ins, and one-tap status updates. Never double-book.' },
        services: { title: 'Services', desc: 'Your menu — cuts, beard, hot-towel, kids. Set duration, price, and which barbers offer each.' },
        products: { title: 'Products', desc: 'Sell pomade, beard oil, and other retail at checkout. Inventory and stock alerts included.' },
        notifications: { title: 'Notifications', desc: 'Email reminders for clients, plus instant booking and cancellation alerts for your team — fully automated.' },
        reports: { title: 'Reports', desc: 'Daily revenue, retention, tip splits, no-show rate. The numbers your accountant asks for, ready.' },
        marketing: { title: 'Marketing', desc: 'Promo posts, sponsor marquees, and seasonal campaigns to fill quiet hours.' },
        qr: { title: 'QR style preview', desc: 'One QR code for your shop. Clients scan it, try haircut styles with AI, and book the look they pick.' },
        settings: { title: 'Settings', desc: 'Hours, holidays, cancellation rules, languages, and team permissions.' },
        onboarding: { title: 'Onboarding', desc: 'A guided 4-step wizard to set up your shop, services, and first chair in under 5 minutes.' },

        setupLabel: 'Setup',
        setupTitlePart1: 'Live in',
        setupTitleAccent: 'under 5 minutes',
        setupTitlePart2: '.',
        setupSub: 'Four steps. No engineering required. Just sign up and start booking.',
        step1Title: 'Create your account',
        step1Desc: 'Sign up in 30 seconds. No credit card required.',
        step2Title: 'Add your shop',
        step2Desc: 'Hours, address and languages.',
        step3Title: 'Add barbers & services',
        step3Desc: 'Build your team and your menu — durations and prices.',
        step4Title: 'Share your booking link',
        step4Desc: 'Add it to Instagram, Google, or print the QR.',

        ctaPrimary: 'Get started free',
        ctaBack: 'Back to home',
        footerCopy: '© 2026 GetFade',
        footerPrivacy: 'Privacy',
        footerTerms: 'Terms',
        footerSecurity: 'Security',
    },

    qrScan: {
        title: 'Scan QR Code',
        subtitle: 'Point your camera at a barbershop QR code to book an appointment',
        openCamera: 'Open Camera',
        clickToStart: 'Click to start scanning',
        notValid: 'This QR code is not valid. Please try another one.',
        valid: 'QR Code Valid!',
        redirecting: 'Redirecting to booking page...',
        invalid: 'Invalid QR Code',
        invalidDesc: "This doesn't appear to be a valid barbershop booking QR code.",
        tryAgain: 'Try Again',
        howItWorks: 'How it works',
        step1: 'Open the camera and point at a QR code',
        step2: 'The code will be scanned automatically',
        step3: "You'll be taken to try haircuts with AI",
        pointCamera: 'Point camera at QR code',
        cameraError: 'Unable to access camera. Please check permissions.',
    },

    portal: {
        myAppointments: 'My Appointments',
        enterPhoneHint: 'Enter your phone number to view your booking history.',
        phoneNumber: 'Phone Number',
        lookingUp: 'Looking up…',
        viewMyAppointments: 'View My Appointments',
        wantToBook: 'Want to book?',
        bookAppointment: 'Book an appointment',
        upcoming: 'Upcoming',
        noUpcoming: 'No upcoming appointments.',
    },
    appWelcome: {
        clientBook: 'Booking a haircut? Find your barbershop',
        tag: 'For barbers & shop owners',
        title: 'Run your shop from your phone',
        sub: 'Bookings, clients and your whole day in one place, with an alert the second someone books.',
        pointAlerts: 'Instant booking alerts',
        pointSchedule: "Today's schedule at a glance",
        create: 'Create account',
        signIn: 'Sign in',
    },
    shopLink: {
        title: 'Book {{shop}} in GetFade',
        sub: 'Get the free GetFade app. It opens {{shop}} as soon as you start it.',
        getApp: 'Get GetFade',
        website: 'Book on the website instead',
    },
    appBook: {
        title: 'Book an appointment',
        sub: 'Scan your barbershop’s QR code or paste its booking link.',
        scan: 'Scan QR code',
        or: 'or',
        linkLabel: 'Booking link',
        linkPlaceholder: 'getfade.io/book/your-barbershop',
        continue: 'Continue',
        invalid: 'That doesn’t look like a GetFade booking link.',
        notFound: 'We couldn’t find that barbershop. Check the link and try again.',
        yourShops: 'Your barbershops',
        staffPrompt: 'Barber or shop owner?',
        staffLink: 'Sign in',
    },
} as const;
